import {
    Box,
    Grid,
    MenuItem,
    Paper,
    Typography,
    Tooltip,
    FormGroup,
    FormControlLabel,
    Checkbox,
    TextField as MuiTextField,
    LinearProgress
} from '@mui/material';
import {
    Client,
    Estimate as NewEstimate,
    FacilityLevelOfCareWithCrossoverDays,
    QuoteMethod,
    Vob,
    PayorPlan,
    Facility,
    Payor,
    Plan, RateAsPayorMap,
    Estimate
} from '@finpay-estimation/estimation-types';
import {
    LoadingOverlay,
    TextField,
    NewLOCSummary,
    checkCrossoverAndUpdateLocs,
    DialogActionButton,
    saveCallbackStatus,
    Button
    // Vob
} from '@finpay-development/shared-components';
import _ from 'lodash';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { RootState } from '../../../shared/state/root-reducer';
import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Alert } from '@finpay-development/shared-platform/lib/esm/meta-data/models/metaData';
import { admissionsAdvisorUtils } from '@finpay-development/shared-platform/lib/esm/admissions-advisor/utils/admission-advisor-utils';
import store, { AppDispatch } from '../../../shared/state/store';
import { useIsDisabledAfterConvert } from '../../hooks/use-is-disabled-after-convert';

import { loadSelectedEstimate, saveSelectedEstimate, saveSelectedEstimateSelfPay, createSelectedEstimate, createSelectedEstimateSelfPay, loadSavedEstimatesListv3 } from '@finpay-development/shared-platform/lib/esm/shared/state/estimator-thunk';
import { estimatorSlice, setSelectedEstimate, clearSelectedEstimate } from '@finpay-development/shared-platform/lib/esm/shared/state/estimator-slice';
import { clearEncounter, setPatientEncounters, setSelectedEncounter } from '@finpay-development/shared-platform/lib/esm/patient/state/patient-slice';
import { clearSelectedVob, setSelectedVob as setSelectedVobState } from '@finpay-development/shared-platform/lib/esm/shared/state/vob-slice';
import { PAYMENT_TYPES } from '@finpay-development/shared-platform/lib/esm/patient/components/models/payment-type';
import { getAlerts } from '@finpay-development/shared-platform/lib/esm/meta-data/state/meta-data-thunk';
import { getPatientDemographics, savePatientStatus } from '@finpay-development/shared-platform/lib/esm/patient/state/patient-thunk';
import { loadPatientVobList } from '@finpay-development/shared-platform/lib/esm/shared/state/vob-thunk';
import { useVobData } from '../vob/vob-form/hooks/useVobData';
import { setPatient } from '@finpay-development/shared-platform/lib/esm/admissions-advisor/state/vob-patient-slice';
import { createPatientIoc } from '@finpay-development/shared-platform/lib/esm/admissions-advisor/state/vob-patient-thunk';
import { IocConfig } from '@finpay-development/shared-platform/lib/esm/admissions-advisor/models/patient';
import { estimatorSchema } from '@finpay-development/shared-platform/lib/esm/shared/validation/schemas';
import { showErrorStatus, showStatus } from '@finpay-development/shared-platform/lib/esm/security/state/user-slice';
import { clearPaymentURLParams } from '@finpay-development/shared-platform/lib/esm/admissions-advisor/state/vob-slice';
import { quoteMethodToDisplayString, stringToQuoteMethod } from 'src/admissions-advisor/components/pfr-estimator/estimator-loc-modal/estimator-loc-modal';
import { EstimatorLevelOfCareModal } from './estimator-loc-modal-v3';
import { AdmissionDateV3 } from './admission-date-v3';
import { EstimatorPriorCareSummary } from './estimator-prior-care-summary-v3';
import { SidebarFinancialSummary } from './sidebar-financial-summary';
import { SidebarPlanYearCrossover } from './sidebar-plan-year-crossover';
import { SidebarTotalEstimatedPfr } from './sidebar-total-estimated-pfr';
import { SidebarPriorCareAdjustment } from './sidebar-prior-care-adjustment';
import { TakePaymentModal } from '../../../shared/components/take-payment-modal';
import { useParams, useNavigate } from 'react-router-dom';
import { loadSelectedVob } from '@finpay-development/shared-platform/lib/esm/shared/state/vob-thunk';
import { patientRecordUtils } from './patient-record-utils';
import { patientService } from '@finpay-development/shared-platform/lib/esm/patient/services/patient-service';
import { getInstanceOfCare } from '@finpay-development/shared-platform/lib/esm/patient/state/patient-thunk';
import { PatientEncounter } from '@finpay-development/shared-platform/lib/esm/patient/components/models/patient-encounter';
import { loadAndSetRateAsPayorPlan, resolvePayorPlanForRateAsLoad } from '../../utils/payor-plan-utils';
import { isSelfPayPayor, loadAndSetRateAsWithoutVob, normalizeDescription } from '../../../shared/utils/insurance-utils';
import { EstimateValidationService } from '../../utils/estimate-validation';
import EstimatesSidebar from "../shared/estimates-sidebar";
import { Utils } from '@finpay-development/shared-platform/lib/esm/shared/utils';
import { getPlanDetails, getSelfPayPayer } from '../../../admissions-advisor/components/inbound/launchV2Utils';
import { getEstimatorFacilityPayers } from '@finpay-development/shared-platform/lib/esm/admissions-advisor/state/vob-thunk';
import { timingRisk, payorRisk } from '@finpay-development/shared-platform/lib/esm/shared/model/timing-and-payor-risk';
import { workFlowStatus } from '@finpay-development/shared-platform/lib/esm/patient/components/models/workflow-status';
import { Workflow } from '@finpay-development/shared-platform/lib/esm/shared/model/client';
import { formatNumberToUSD } from '@finpay-development/shared-platform/lib/esm/shared/calculators';

function EstimateTab() {
    const state = {
        clients: useSelector(
            (state: RootState) =>
                state.implementationContext.implementationSpecialistClient
                    .filteredByIsActive
        ),
        allClients: useSelector(
            (state: RootState) =>
                state.implementationContext?.implementationSpecialistClient.allClientsMap
        ),
        isLoadingClients: useSelector(
            (state: RootState) =>
                state.implementationContext.implementationSpecialistClient
                    .isLoading
        ),
        isLoadingFacilities: useSelector(
            (state: RootState) =>
                state.implementationContext.implementationFacility.isLoading
        ),
        vob: useSelector(
            (state: RootState) => state.vobContext.selectedVob
        ),
        vobPatientState: useSelector(
            (state: RootState) =>
                state.admissionsAdvisorContext.vobPatientContext
        ),
        vobPatient: useSelector(
            (state: RootState) =>
                state.admissionsAdvisorContext?.vobPatientContext.patient
        ),
        estimatorLoadingState: useSelector(
            (state: RootState) =>
                state.estimatorContext.isLoading
        ),
        clientAlerts: useSelector((state: RootState) => {
            return state.metaData.alerts;
        }),
        clientLevelsOfCareState: useSelector((state: RootState) => {
            return state.admissionsAdvisorContext.estimatorContext
                ?.clientLevelsOfCare;
        }),
        payors: useSelector(
            (state: RootState) =>
                state.adminContext.adminConfigurationContext?.payers
        ),
        masterLevelsOfCareState: useSelector((state: RootState) => {
            return state?.adminContext.adminConfigurationContext?.levelsOfCare;
        }),
        estimate: useSelector((state: RootState) => {
            return state?.estimatorContext.selectedEstimate;
        }),
        facilityLevelsOfCareList: useSelector((state: RootState) => {
            return state?.estimatorContext.facilityLevelsOfCareList;
        }),
        userProfile: useSelector(
            (state: RootState) => state.userContext.userProfile
        ),
        selectedPatient: useSelector((state: RootState) => {
            return state?.patientContext.selectedPatient;
        }),
        savedEstimations: useSelector(
            (state: RootState) =>
                state.estimatorContext.savedEstimatesList
        ),
        savedEstimatesLoading: useSelector(
            (state: RootState) =>
                state.estimatorContext.isLoading.savedEstimatesList
        ),
        patientVobList: useSelector(
            (state: RootState) => state.vobContext.patientVobList
        ),
        patientVobListLoading: useSelector(
            (state: RootState) => state.vobContext.isLoading?.patientVobList
        ),
        reduxRateAsPayorMap: useSelector((state: RootState) => state.estimatorContext.rateAsPayorMap) || {},
        reduxMasterPayors: useSelector((state: RootState) => state.adminContext.adminConfigurationContext?.payersMap) || new Map(),
        selectedEncounter: useSelector((state: RootState) => {
            return state?.patientContext.selectedEncounter;
        }),
        selectedPatientEncounters: useSelector(
            (state: RootState) =>
                state.patientContext?.selectedPatient.patientEncounters
        ),
        rateAsPayorPlan: useSelector((state: RootState) => {
            return state.estimatorContext.rateAsPayorPlan as PayorPlan;
        }),
        payers: useSelector((state: RootState) => {
            return state.adminContext.adminConfigurationContext?.payers;
        })
    };

    const {
        clients,
        allClients,
        isLoadingClients,
        vob,
        vobPatientState,
        vobPatient,
        clientAlerts,
        clientLevelsOfCareState,
        payors,
        estimate,
        facilityLevelsOfCareList,
        userProfile,
        selectedPatient,
        savedEstimations,
        savedEstimatesLoading,
        patientVobList,
        patientVobListLoading,
        selectedEncounter,
        selectedPatientEncounters,
        estimatorLoadingState,
        rateAsPayorPlan,
        payers
    } = state;

    const [isLOCModalOpen, setIsLOCModalOpen] = useState(false);
    const [openPaymentModal, setOpenPaymentModal] = useState(false);
    const [paymentData, setPaymentData] = useState<any>(undefined);
    const [selectedFacility, setSelectedFacility] = useState<number | ''>('');
    const [facilitiesLoading, setFacilitiesLoading] = useState(false);
    const [facilities, setFacilities] = useState<any>([]);
    const [payerAlerts, setPayerAlerts] = useState<Alert[]>([]);
    const [employerAlerts, setEmployerAlerts] = useState<Alert[]>([]);
    const [groupAlerts, setGroupAlerts] = useState<Alert[]>([]);
    const [prefixAlerts, setPrefixAlerts] = useState<Alert[]>([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isCopying, setIsCopying] = useState(false);
    const [isPrivatePay, setIsPrivatePay] = useState(false);
    const [isPrivatePaySwitching, setIsPrivatePaySwitching] = useState(false);
    const hasInitFromEstimate = useRef(false);
    const hasCheckedPaymentUrl = useRef(false);

    const [doesLOCSummaryValNeedUpdating, setDoesLOCSummaryValNeedUpdating] =
        useState(false);

    const dispatch = useDispatch<AppDispatch>();
    const { estimateId, patientId } = useParams<{ estimateId?: string, patientId?: string }>();
    const navigate = useNavigate();

    const selectedPatientCurrentInsurance = useSelector(
        (state: RootState) => state.patientContext.selectedPatientCurrentInsurance
    );

    const payersMap = useSelector(
        (state: RootState) => state.adminContext.adminConfigurationContext.payersMap
    );
    // Check if patient has self-pay insurance
    const isSelfPay = useMemo(() => {
        return isSelfPayPayor(selectedPatientCurrentInsurance?.payorId, payersMap);
    }, [selectedPatientCurrentInsurance?.payorId, payersMap]);

    const isDisabledAfterConvert = useIsDisabledAfterConvert();
    const isIOCConverted = selectedEncounter &&
        Number(selectedEncounter.patientEncounterId) === Number(estimate?.patientEncounterId) &&
        (selectedEncounter.isConverted || selectedEncounter.workflow?.workflowId === 3);
    const isIocLinkedToEstimate =
        selectedEncounter?.pfrEstimateId != null &&
        estimate?.estimateId != null &&
        Number(selectedEncounter.pfrEstimateId) === Number(estimate.estimateId);
    // Add state for dropdowns
    const [vobsList, setVobsList] = useState<any[]>([]);
    const [selectedVob, setSelectedVob] = useState<string>(vob?.vobId?.toString() || '');
    const [isLoadingEstimate, setIsLoadingEstimate] = useState(false);

    // Add ref to track if this is initial load
    const isInitialLoad = useRef(true);
    const isManualVobChange = useRef(false);
    const hasAutoSelectedFirstEstimate = useRef(false);
    const isLoadingIOCRef = useRef(false);
    const lastLoadedPatientIdRef = useRef<number | undefined>(undefined);
    const lastSyncedEstimateVobRef = useRef<{ estimateId?: number; vobId?: number }>({});
    const paramId: number = -2;

    useEffect(() => {
        forceValidateOnload();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch]);

    // if the client is configured with the feature flag, use the new estimate values, otherwise use the estimator state values, otherwise use the vob values
    const currentClientId = estimate?.clientId
        ? estimate.clientId
        : vob?.client?.clientId
            ? vob.client.clientId
            : selectedPatient?.clientId;
    const currentFacilityId = estimate?.facilityId
        ? estimate.facilityId
        : vob?.facility?.facilityId;
    const initialAdmissionDate = useMemo(() => {
        if (estimate?.anticipatedAdmitDate) {
            // If we have an existing date, convert it to a Date object for the DatePicker
            return new Date(estimate.anticipatedAdmitDate);
        }
        console.log('init admit date', estimate);
        // For new estimates, use today's date
        return new Date();

    }, [estimate?.anticipatedAdmitDate]);
    const initialQuoteMethod = estimate?.quoteMethod
        ? estimate.quoteMethod
        : QuoteMethod.AVGLOS;

    const [admissionDate, setAdmissionDate] = useState(initialAdmissionDate);

    // Create facilities array for useVobData hook - memoized to prevent infinite re-renders
    const facilitiesArray = useMemo(() => {
        return currentClientId && allClients.get(Number(currentClientId))?.clientFacilities
            ? allClients.get(Number(currentClientId))!.clientFacilities
            : [];
    }, [currentClientId, allClients]);

    const defaultTimingRiskId = 1; // 'Precare'
    const isSelfPayOrPrivatePay = isSelfPay || isPrivatePay;

    const resolvePayorRiskId = (): number => {
        if (isSelfPayOrPrivatePay) return 3; // 'Self-Pay'
        if (rateAsPayorPlan?.payor) return rateAsPayorPlan.payor.inNetwork ? 1 : 2; // 'In Network' or 'Out of Network'

        const existingPayorRiskId = Number(selectedEncounter?.payorRisk?.payorRiskId);
        if (Number.isFinite(existingPayorRiskId) && existingPayorRiskId > 0) {
            return existingPayorRiskId;
        }
        throw new Error('Failed to resolve payor risk');
    };

    // Use shared VOB utilities
    const { getVobDisplayText } = useVobData({
        facilities: facilitiesArray,
        includeReduxVobs: true
    });

    useEffect(() => {
        setAdmissionDate(initialAdmissionDate);
    }, [initialAdmissionDate]);

    // Fetch VOB if it's empty but estimate has vobId
    useEffect(() => {
        if (estimate?.vobId && (!vob || !vob.vobId)) {
            const fetchVob = async () => {
                try {
                    console.log('Fetching VOB with vobId:', estimate.vobId);
                    await dispatch(loadSelectedVob({ vobId: estimate.vobId }));

                    // Note: rateAsPayorPlan will be set automatically by other effects once VOB data is available

                    // After VOB loads, fetch saved estimates if this is initial load
                    if (isInitialLoad.current) {
                        try {
                            await dispatch(
                                loadSavedEstimatesListv3({
                                    paramId: paramId,
                                    patientId: Number(patientId),
                                })
                            );
                            isInitialLoad.current = false;
                        } catch (error) {
                            console.error('Error fetching saved estimates:', error);
                            dispatch(showErrorStatus('Error loading saved estimates. Please try again.'));
                        }
                    }
                } catch (error) {
                    console.error('Error fetching VOB:', error);
                    dispatch(showErrorStatus('Error loading VOB data. Please try again.'));
                }
            };
            fetchVob();
        }
    }, [estimate?.vobId, vob?.vobId, dispatch]);

    // When Estimate tab mounts: sync Redux rateAsPayorPlan once (Private Pay => loadAndSetRateAsWithoutVob, else => loadAndSetRateAsPayorPlan with vob). Use estimate?.isPrivatePay (not state) so we don't run before isPrivatePay has been set from estimate.
    useEffect(() => {
        if (!estimate) return;
        const facilityId = estimate?.facilityId ?? vob?.facility?.facilityId;
        const isPrivatePayFromEstimate = !!estimate.isPrivatePay;
        if (isPrivatePayFromEstimate || isSelfPay) {
            if (!facilityId) return;
            const runSync = async () => {
                try {
                    const sssconfig: any = {
                        paramId: paramId,
                        masterListPayers: payers,
                        facilityId,
                    };
                    const facilityPayors = await dispatch(getEstimatorFacilityPayers(sssconfig));
                    const selfPayPayor = getSelfPayPayer(facilityPayors);
                    const selectedPlan = getPlanDetails(selfPayPayor, facilityPayors);
                    const updatedPatientCurrentInsurance = {
                        ...selectedPatientCurrentInsurance,
                        payorId: selfPayPayor?.cfgPayorId,
                        payorPlanId: selectedPlan?.payorPlanId,
                    };
                    const loadAndSetRateAsPayorPlanAdapter = async (
                        facility: any,
                        disp: Dispatch<any>,
                        payersArg: any,
                        payor: Payor,
                        plan: Plan
                    ): Promise<void> => {
                        const clientId = estimate?.clientId || selectedPatient?.clientId ? Number(estimate?.clientId || selectedPatient?.clientId) : 0;
                        const clientObj = { clientId } as Client;
                        if (!estimate?.facilityId) return;
                        const targetClient = allClients.get(Number(clientId));
                        const facilityFromClient = targetClient?.clientFacilities?.find(
                            (f: any) => f.facilityId === Number(estimate.facilityId)
                        );
                        const estimateFacility: Facility = facilityFromClient
                            ? { facilityId: facilityFromClient.facilityId, facilityName: facilityFromClient.facilityName } as Facility
                            : { facilityId: Number(estimate.facilityId) } as Facility;
                        await loadAndSetRateAsPayorPlan(
                            clientObj,
                            estimateFacility,
                            disp,
                            state.reduxMasterPayors,
                            payor,
                            plan,
                            state.reduxRateAsPayorMap,
                            estimate!,
                            rateAsPayorPlan,
                            vob!,
                            estimate,
                            vob?.vobId
                        );
                    };
                    await loadAndSetRateAsWithoutVob({
                        selectedPatient,
                        patientDemographicResp: null,
                        selectedPatientCurrentInsurance: updatedPatientCurrentInsurance,
                        patientInsuranceResp: null,
                        allClientsMap: allClients,
                        dispatch,
                        payers,
                        loadAndSetRateAsPayorPlan: loadAndSetRateAsPayorPlanAdapter
                    });
                } catch (err) {
                    console.error('Error syncing rateAsPayorPlan for Private/Self Pay on Estimate tab:', err);
                }
            };
            runSync();
        } else if (vob?.payor && vob?.plan) {
            const runSync = async () => {
                try {
                    const vobFacilityId = vob?.facility?.facilityId;
                    const estimateFacilityId = estimate?.facilityId;
                    const facilityToUse = vobFacilityId || estimateFacilityId;
                    let facilityObj: Facility;
                    if (facilityToUse && currentClientId) {
                        const targetClient = allClients.get(Number(currentClientId));
                        const facilityFromClient = targetClient?.clientFacilities?.find(
                            (f: any) => f.facilityId === Number(facilityToUse)
                        );
                        facilityObj = facilityFromClient
                            ? { facilityId: facilityFromClient.facilityId, facilityName: facilityFromClient.facilityName } as Facility
                            : vob?.facility || { facilityId: Number(facilityToUse) } as Facility;
                    } else {
                        facilityObj = vob?.facility || { facilityId: Number(facilityToUse) } as Facility;
                    }
                    const clientObj = vob?.client || { clientId: currentClientId } as Client;
                    const resolvedPayorPlan = resolvePayorPlanForRateAsLoad(vob, estimate);
                    if (!resolvedPayorPlan) {
                        return;
                    }
                    await loadAndSetRateAsPayorPlan(
                        clientObj,
                        facilityObj,
                        dispatch,
                        state.reduxMasterPayors,
                        resolvedPayorPlan.payor,
                        resolvedPayorPlan.plan,
                        state.reduxRateAsPayorMap,
                        estimate!,
                        rateAsPayorPlan,
                        vob!,
                        estimate,
                        vob?.vobId
                    );
                } catch (err) {
                    console.error('Error syncing rateAsPayorPlan with VOB on Estimate tab:', err);
                }
            };
            runSync();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- run only once on Estimate tab mount
    }, []);

    // Note: Facility levels of care are now fetched by payor-plan-utils.ts when setting rateAsPayorPlan

    //to do : if estimate does not have a valid VOb then nav to vob tab

    // setting up clientAlerts
    // needs client id from vob and the meta data
    useEffect(() => {
        const clientId = vob?.client?.clientId;

        // possible that we are still loading vob
        if (!clientId) return;

        const alerts = clientAlerts[clientId];

        // if we have a client id and our client's alerts, set everything
        if (clientId && alerts) {
            const payerAlerts = clientAlerts[clientId].payer.filter(
                payerAlert => {
                    return payerAlert.payor_id === vob.payor.payorId;
                }
            );

            const groupAlerts = clientAlerts[clientId].group.filter(
                groupAlert => {
                    return groupAlert?.group_code === vob.groupNum;
                }
            );

            const employerAlerts = clientAlerts[clientId].employer.filter(
                employerAlert => {
                    return (
                        employerAlert.client_employer_id ===
                        vob.employer?.employerId
                    );
                }
            );

            let newPrefixAlerts: Alert[] = [];
            const prefixes = clientAlerts[clientId].prefix;

            for (let i = 0; i < prefixes.length; i++) {
                if (prefixes.length > 0) {
                    const prefixAlert = prefixes[i];
                    const subStringEndingIndex = prefixAlert.prefix!.length;

                    const policyNumberSubString = vob?.policyNum?.substring(
                        0,
                        subStringEndingIndex
                    );

                    const isAMatch =
                        policyNumberSubString === prefixAlert.prefix;
                    // match
                    if (isAMatch) {
                        // if nothing in the new alerts, add it
                        if (newPrefixAlerts.length === 0) {
                            newPrefixAlerts.push(prefixAlert);
                            continue;
                        }

                        // length is same as the first prefix
                        if (
                            newPrefixAlerts[0].prefix!.length ===
                            prefixAlert.prefix!.length
                        ) {
                            // add it the list, don't replace
                            newPrefixAlerts.push(prefixAlert);
                            continue;
                        }

                        // length is greater than the first prefix
                        if (
                            newPrefixAlerts[0].prefix!.length <
                            prefixAlert.prefix!.length
                        ) {
                            // replace with new alert
                            newPrefixAlerts = [prefixAlert];
                            continue;
                        }
                    }
                }
            }

            setPayerAlerts(payerAlerts);
            setGroupAlerts(groupAlerts);
            setPrefixAlerts(newPrefixAlerts);
            setEmployerAlerts(employerAlerts);
        } else if (clientId && !clientAlerts[clientId]) {
            // client id but no alerts, fetch the alerts
            dispatch(getAlerts(clientId));
        }
    }, [vob, clientAlerts]);

    useEffect(() => {
        // run once, the first time estimate becomes truthy
        if (!estimate || hasInitFromEstimate.current) return;
        hasInitFromEstimate.current = true;
        setIsPrivatePay(!!estimate.isPrivatePay);

    }, [estimate]);

    const setAdvisorPatientBody = async () => {
        if (vobPatientState.patient.fpPatientId) {
            const {payload}: {payload: any} = await dispatch(
                getPatientDemographics(vobPatientState.patient.fpPatientId!)
            );

            await dispatch(
                setPatient({
                    advisorPatientBody: {
                        email: payload.patientDetails.contact.email,
                        primaryAddress: {
                            streetAddress1:
                            payload.patientDetails?.contact?.primaryAddress
                                ?.streetAddress1,
                            streetAddress2:
                            payload.patientDetails?.contact?.primaryAddress
                                ?.streetAddress2,
                            city: payload.patientDetails?.contact
                                ?.primaryAddress?.city,
                            state: {
                                stateCode:
                                payload.patientDetails.contact
                                    .primaryAddress?.state?.stateCode,
                            },
                            zipCode:
                            payload.patientDetails?.contact?.primaryAddress
                                ?.zipCode,
                        },
                        phoneNumber:
                        payload.patientDetails?.contact?.primPhoneNum,
                    },
                })
            );
        }
    };

    useEffect(() => {
        setAdvisorPatientBody();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (hasCheckedPaymentUrl.current) return;

        const urlParams = new URLSearchParams(window.location.search);
        const opParam = urlParams.get('op');

        if (opParam === 'pay' && patientId && (selectedEncounter?.patientEncounterId || estimate?.patientEncounterId)) {
            const clientIdNum =
                estimate?.clientId != null
                    ? Number(estimate.clientId)
                    : vob?.client?.clientId != null
                      ? Number(vob.client.clientId)
                      : selectedPatient?.clientId != null
                        ? Number(selectedPatient.clientId)
                        : NaN;

            if (!Number.isFinite(clientIdNum)) {
                return;
            }

            const clientVm = allClients?.get(clientIdNum);
            if (clientVm?.billingEngineVersion?.toUpperCase() === 'V3') {
                // Parent EstimatesView redirects V3 + ?op=pay to Payment Hub; do not flash Take Payment
                hasCheckedPaymentUrl.current = true;
                return;
            }

            setPaymentData({
                patientId: patientId,
                patientEncounterId: selectedEncounter?.patientEncounterId || estimate?.patientEncounterId,
                paymentType: PAYMENT_TYPES.DOWN_PAYMENT,
                paymentChannelId: userProfile.userRole.roleType === 'I' ? 5 : 3
            });
            setOpenPaymentModal(true);
            hasCheckedPaymentUrl.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [estimate, selectedEncounter, patientId, allClients, vob, selectedPatient]);

    async function handleEstimatorLevelOfCareModalClose() {
        console.log(
            '%cLOC Modal Close - Formik:',
            'background-color: #0199cc; color: white; font-weight: bold',
            createEstimatorFormik.values
        );
        console.log(
            '%cLOC Modal Close - Estimator State:',
            'background-color: #0199cc; color: white; font-weight: bold',
            estimate
        );
        console.log(
            '%cLOC Modal Open - Vob State:',
            'background-color: #0199cc; color: white; font-weight: bold',
            vob
        );
        console.log(
            '%cLOC Modal Open - Client LOCState:',
            'background-color: #0199cc; color: white; font-weight: bold',
            clientLevelsOfCareState
        );
        setIsLOCModalOpen(false);
        // update estimate list post save
        await dispatch(
            loadSavedEstimatesListv3({
                paramId: paramId,
                patientId: Number(patientId),
            })
        );
    }

    const estimatorValidationSchema = Yup.object(estimatorSchema);

    // formik for estimator and IOC
    const createEstimatorFormik = useFormik({
        initialValues: {
            client: currentClientId,
            facility: currentFacilityId,
            quoteMethod: initialQuoteMethod,
            timingRisk: selectedEncounter?.timingRisk?.timingRiskId ?? defaultTimingRiskId,
            interactionType: ''
        },
        enableReinitialize: true,
        validationSchema: estimatorValidationSchema,
        onSubmit: () => {},
    });

    const handleNewEstimateQuoteMethodChange = async (e: Event) => {
        try {
            const selectedQuoteMethod = (e.target as HTMLInputElement)
                .value as unknown as QuoteMethod;

            if (estimate) {
                //estimate already exists

                let putEstimateBody: NewEstimate | undefined;

                switch (true) {
                    case selectedQuoteMethod === QuoteMethod.SCA: {
                        setDoesLOCSummaryValNeedUpdating(true);

                        putEstimateBody = {
                            vobId: vob?.vobId!,
                            patientEncounterId: estimate?.patientEncounterId,
                            clientId: estimate?.clientId,
                            facilityId: estimate?.facilityId,
                            advisorPatientId: estimate?.advisorPatientId || 1,
                            patientId: selectedPatient.patientId,
                            description: normalizeDescription(estimate?.description, estimate.isPrivatePay || isPrivatePay, isSelfPay),
                            quoteMethod: selectedQuoteMethod,
                            anticipatedAdmitDate: new Date(admissionDate),
                            facilityLevelOfCare: estimate.facilityLevelOfCare,
                            priorCare: estimate.priorCare,
                            isPlanYearCrossover: estimate.isPlanYearCrossover,
                            crossoverSelection: estimate?.crossoverSelection,
                            isActive: estimate.isActive,
                            rateAsPayorPlan: rateAsPayorPlan,
                            isSelfPay: isSelfPay,
                            isPrivatePay: estimate.isPrivatePay || isPrivatePay,
                        };

                        break;
                    }

                    case selectedQuoteMethod === QuoteMethod.MANUAL: {
                        setDoesLOCSummaryValNeedUpdating(true);

                        const updatedFacilityLevelOfCare =
                            estimate?.facilityLevelOfCare?.map(facLOC => {
                                const foundFacLOCFromList =
                                    facilityLevelsOfCareList?.find(
                                        facLOCFromList => {
                                            return (
                                                facLOC.facilityLevelOfCareId ==
                                                facLOCFromList.facilityLevelOfCareId
                                            );
                                        }
                                    );

                                if (foundFacLOCFromList) {
                                    return {
                                        ...facLOC,
                                        pdrRate: foundFacLOCFromList.pdrRate,
                                    };
                                } else {
                                    throw new Error(
                                        'Could not find facility level of care from newFacilityLevelsOfCareList Redux state'
                                    );
                                }
                            });

                        putEstimateBody = {
                            vobId: vob?.vobId!,
                            patientEncounterId: estimate?.patientEncounterId,
                            clientId: estimate?.clientId,
                            facilityId: estimate?.facilityId,
                            advisorPatientId: estimate?.advisorPatientId || 1,
                            patientId: selectedPatient.patientId,
                            description: normalizeDescription(estimate?.description, estimate.isPrivatePay || isPrivatePay, isSelfPay),
                            quoteMethod: selectedQuoteMethod,
                            anticipatedAdmitDate: new Date(admissionDate),
                            facilityLevelOfCare: updatedFacilityLevelOfCare,
                            priorCare: estimate.priorCare,
                            isPlanYearCrossover: estimate.isPlanYearCrossover,
                            crossoverSelection: estimate?.crossoverSelection,
                            isActive: estimate.isActive,
                            rateAsPayorPlan: rateAsPayorPlan,
                            isSelfPay: isSelfPay,
                            isPrivatePay: estimate.isPrivatePay || isPrivatePay,
                        };

                        break;
                    }

                    case [QuoteMethod.AVGLOS, QuoteMethod.RLOS].includes(
                        selectedQuoteMethod
                    ): {
                        // Any quote method -> avlos/rlos

                        let updatedFacilityLevelOfCare =
                            estimate?.facilityLevelOfCare?.map(facLOC => {
                                const foundFacLOCFromList =
                                    facilityLevelsOfCareList?.find(
                                        facLOCFromList => {
                                            return (
                                                facLOC.facilityLevelOfCareId ==
                                                facLOCFromList.facilityLevelOfCareId
                                            );
                                        }
                                    );

                                if (foundFacLOCFromList) {
                                    return {
                                        ...facLOC,
                                        losDays:
                                            selectedQuoteMethod ===
                                            QuoteMethod.AVGLOS
                                                ? foundFacLOCFromList.losDays
                                                : foundFacLOCFromList.recommendedLos,
                                        pdrRate: foundFacLOCFromList.pdrRate,
                                    };
                                } else {
                                    throw new Error(
                                        'Could not find facility level of care from newFacilityLevelsOfCareList Redux state'
                                    );
                                }
                            });

                        const { isCrossover, newSelectedLocs } = (isSelfPay || isPrivatePay)
                            ? {
                                isCrossover: false,
                                newSelectedLocs: updatedFacilityLevelOfCare as FacilityLevelOfCareWithCrossoverDays[],
                            }
                            : checkCrossoverAndUpdateLocs({
                                selectedLocs:
                                    updatedFacilityLevelOfCare as FacilityLevelOfCareWithCrossoverDays[],
                                admissionDate: new Date(admissionDate),
                                policyEndDate: new Date(vob?.policyEndDate!),
                            });

                        /**
                         * Because the endpoint doesn't allow request bodies with missing losDaysBeforeCrossover/losDaysAfterCrossover properties if isPlanYearCrossover === true,
                         * we will set isPlanYearCrossover to false and prompt the user to update from the modal
                         * */

                        promptUserToUpdateModalForCrossover =
                            admissionsAdvisorUtils.isModalUpdateNeededForCrossover(
                                {
                                    isCrossover,
                                    newSelectedLocs,
                                    policyEndDate: new Date(vob?.policyEndDate!),
                                    anticipatedAdmissionDate: new Date(
                                        admissionDate
                                    ),
                                }
                            );

                        putEstimateBody = {
                            vobId: vob?.vobId!,
                            patientEncounterId: estimate?.patientEncounterId,
                            clientId: estimate?.clientId,
                            facilityId: estimate?.facilityId,
                            advisorPatientId: estimate?.advisorPatientId || 1,
                            patientId: selectedPatient.patientId,
                            description: normalizeDescription(estimate?.description, estimate.isPrivatePay || isPrivatePay, isSelfPay),
                            quoteMethod: selectedQuoteMethod,
                            anticipatedAdmitDate: new Date(admissionDate),
                            facilityLevelOfCare:
                                promptUserToUpdateModalForCrossover
                                    ? updatedFacilityLevelOfCare
                                    : newSelectedLocs,
                            priorCare: estimate.priorCare,
                            isPlanYearCrossover:
                                promptUserToUpdateModalForCrossover
                                    ? false
                                    : isCrossover,
                            crossoverSelection: estimate?.crossoverSelection,
                            isActive: estimate.isActive,
                            summarySelection: estimate?.summarySelection,
                            rateAsPayorPlan: rateAsPayorPlan,
                            isSelfPay: isSelfPay,
                            isPrivatePay: estimate.isPrivatePay || isPrivatePay,
                        };

                        break;
                    }

                    default:
                }

                if (putEstimateBody) {
                    await dispatch(
                        (isSelfPay || isPrivatePay)
                            ? saveSelectedEstimateSelfPay({ estimateId: estimate.estimateId, estimate: putEstimateBody })
                            : saveSelectedEstimate({ estimateId: estimate.estimateId, estimate: putEstimateBody })
                    );

                    // Refresh the saved estimates list to show updated description
                    await dispatch(loadSavedEstimatesListv3({
                        paramId: paramId,
                        patientId: Number(patientId),
                    }));
                }
            }
        } catch (e) {
            console.error(e);
            dispatch(
                showErrorStatus('Error updating quote method and Level of Care')
            );
        }
    };

    let promptUserToUpdateModalForCrossover: boolean = false;

    // Only calculate crossover if we have a valid VOB with policyEndDate
    if (vob?.policyEndDate && estimate?.facilityLevelOfCare) {
        const crossoverResult = (isSelfPay || isPrivatePay)
            ? {
                isCrossover: false,
                newSelectedLocs: estimate?.facilityLevelOfCare as FacilityLevelOfCareWithCrossoverDays[],
            }
            : checkCrossoverAndUpdateLocs({
                selectedLocs: estimate?.facilityLevelOfCare as FacilityLevelOfCareWithCrossoverDays[],
                admissionDate: new Date(admissionDate),
                policyEndDate: new Date(vob.policyEndDate),
            });

        promptUserToUpdateModalForCrossover = admissionsAdvisorUtils.isModalUpdateNeededForCrossover({
            ...crossoverResult,
            policyEndDate: new Date(vob.policyEndDate),
            anticipatedAdmissionDate: new Date(admissionDate),
        });
    }


    const handleAdmissionDateOnChange = async (date: Date) => {
        try {
            const selectedAdmissionDate = new Date(date);
            setAdmissionDate(selectedAdmissionDate);

            if (estimate) {
                //estimate already exists
                const { isCrossover, newSelectedLocs } = (isSelfPay || isPrivatePay)
                    ? {
                        isCrossover: false,
                        newSelectedLocs: estimate.facilityLevelOfCare as FacilityLevelOfCareWithCrossoverDays[],
                    }
                    : checkCrossoverAndUpdateLocs({
                        selectedLocs: estimate.facilityLevelOfCare as FacilityLevelOfCareWithCrossoverDays[],
                        admissionDate: selectedAdmissionDate,
                        policyEndDate: new Date(vob?.policyEndDate!),
                    });

                /**
                 * Because the endpoint doesn't allow request bodies with missing losDaysBeforeCrossover/losDaysAfterCrossover properties if isPlanYearCrossover === true,
                 * we will set isPlanYearCrossover to false and prompt the user to update from the modal
                 * */

                promptUserToUpdateModalForCrossover =
                    admissionsAdvisorUtils.isModalUpdateNeededForCrossover({
                        isCrossover,
                        newSelectedLocs,
                        policyEndDate: new Date(vob?.policyEndDate!),
                        anticipatedAdmissionDate: selectedAdmissionDate,
                    });

                let putEstimateBody = {
                    ..._.omit(estimate, [
                        'estimateId',
                        'createUserId',
                        'createDt',
                        'lastUpdateUserId',
                        'lastUpdateDt',
                        'summary',
                        'crossOverSummary',
                        'priorCareSummary',
                    ]),
                    patientId: selectedPatient.patientId,
                    vobId: vob?.vobId!,
                    advisorPatientId: estimate?.advisorPatientId || 1,
                    anticipatedAdmitDate: selectedAdmissionDate,
                    description: normalizeDescription(estimate?.description, estimate.isPrivatePay || isPrivatePay, isSelfPay),
                    facilityLevelOfCare: promptUserToUpdateModalForCrossover
                        ? estimate.facilityLevelOfCare
                        : newSelectedLocs,
                    isPlanYearCrossover: promptUserToUpdateModalForCrossover
                        ? false
                        : isCrossover,
                    rateAsPayorPlan: rateAsPayorPlan,
                    isSelfPay: isSelfPay,
                    isPrivatePay: estimate.isPrivatePay || isPrivatePay,
                };

                await dispatch(
                    (isSelfPay || isPrivatePay)
                        ? saveSelectedEstimateSelfPay({ estimateId: estimate.estimateId, estimate: putEstimateBody })
                        : saveSelectedEstimate({ estimateId: estimate.estimateId, estimate: putEstimateBody })
                );

                // Refresh the saved estimates list to show updated description
                await dispatch(loadSavedEstimatesListv3({
                    paramId: paramId,
                    patientId: Number(patientId),
                }));
            }
        } catch (e) {
            console.error(e);
            dispatch(
                showErrorStatus('Error updating Anticipated Admission Date')
            );
        }
    };

    const forceValidateOnload = () => {
        setTimeout(() => {
            createEstimatorFormik.validateForm(); // unlock the IOC
        }, 500);
    };


    const handlePaymentModalCancel = () => {
        setOpenPaymentModal(false);
        dispatch(clearPaymentURLParams());
    };

    const quoteMethodValueAsEnum =
        typeof createEstimatorFormik.values.quoteMethod === 'string'
            ? stringToQuoteMethod(createEstimatorFormik.values.quoteMethod)
            : createEstimatorFormik.values.quoteMethod;
    const quoteMethodValueAsDisplayString =
        quoteMethodToDisplayString(initialQuoteMethod);

    const currentClient = currentClientId && allClients ?
        allClients.get(Number(currentClientId)) : undefined;

    const currentFacility = currentClientId && currentFacilityId && allClients && currentClient ?
        currentClient.clientFacilities?.find(facility =>
            facility.facilityId === currentFacilityId
        ) : undefined;

    useEffect(() => {
        // Only fetch estimates when we have a VOB loaded and it wasn't loaded from estimate (i.e., tab navigation)
        if (vob?.vobId && !estimate?.vobId && isInitialLoad.current) {
            const fetchSavedEstimates = async () => {
                try {
                    await dispatch(
                        loadSavedEstimatesListv3({
                            paramId: paramId,
                            patientId: Number(patientId),
                        })
                    );
                    // Mark initial load as complete
                    isInitialLoad.current = false;
                } catch (error) {
                    console.error('Error fetching saved estimates:', error);
                    dispatch(showErrorStatus('Error loading saved estimates. Please try again.'));
                }
            };
            fetchSavedEstimates();
        }
    }, [vob?.vobId, estimate?.vobId, dispatch]);

    useEffect(() => {
        if (isSelfPay || isPrivatePay) {
            const fetchFacilities = async () => {
                setFacilitiesLoading(true);
                try {
                    const clientId = Number(selectedPatient?.clientId);
                    const targetClient = allClients?.get(clientId);
                    if (targetClient?.clientFacilities) {
                        setFacilities(targetClient.clientFacilities);
                        if (estimate?.facilityId) {
                            setSelectedFacility(Number(estimate?.facilityId));
                        } else {
                            if (targetClient.clientFacilities.length > 0) {
                                const facilityId = targetClient.clientFacilities[0].facilityId;
                                setSelectedFacility(facilityId);
                            }
                        }
                    }
                } catch (err) {
                    console.error('Error fetching facilities:', err);
                } finally {
                    setFacilitiesLoading(false);
                }
            };
            fetchFacilities();
        }
    }, [isSelfPay, isPrivatePay, estimate?.facilityId, selectedPatient?.clientId, allClients]);

    // Derive the selected estimate value from current state
    const selectedEstimateValue = estimateId || estimate?.estimateId?.toString() || '';

    useEffect(() => {
        if (
            !estimateId &&
            !hasAutoSelectedFirstEstimate.current &&
            savedEstimations &&
            savedEstimations.length > 0 &&
            !estimate &&
            !savedEstimatesLoading &&
            !isLoadingEstimate &&
            selectedPatient?.patientId
        ) {
            const firstEstimate = (savedEstimations as any[])[0];
            const firstEstimateId = firstEstimate?.pfrEstimateId || firstEstimate?.estimateId;

            if (firstEstimateId) {
                hasAutoSelectedFirstEstimate.current = true;
                setIsLoadingEstimate(true);

                navigate(`/patients/${selectedPatient.patientId}/estimate/${firstEstimateId}`, { replace: true });

                dispatch(
                    loadSelectedEstimate({
                        paramId: paramId,
                        estimationId: Number(firstEstimateId)
                    })
                ).finally(() => {
                    setIsLoadingEstimate(false);
                });
            }
        }
    }, [estimateId, savedEstimations, estimate, savedEstimatesLoading, isLoadingEstimate, selectedPatient, dispatch, navigate, paramId]);

    // Fetch Patient VOBs if empty
    useEffect(() => {
        if (patientId && (!patientVobList || patientVobList.length === 0)) {
            dispatch(loadPatientVobList(Number(patientId)));
        }
    }, [patientId, dispatch]);

    // Fetch available VOBs for dropdown and select the appropriate VOB
    useEffect(() => {
        if (patientVobList && patientVobList.length > 0) {
            // Filter valid VOBs and map them to dropdown format using shared utilities
            const formattedVobs = patientVobList
                .filter(patientVob => patientVob.isValid === true)
                .map(patientVob => ({
                    id: patientVob.vobId || 0,
                    name: getVobDisplayText(patientVob)
                }));

            setVobsList(formattedVobs);


            if (!isManualVobChange.current) {
                // Set the VOB that's linked to the selected estimate
                if (estimate?.vobId) {
                    setSelectedVob(estimate.vobId.toString());
                }
                // If no estimate.vobId, then use current vob if available
                else if (vob?.vobId) {
                    setSelectedVob(vob.vobId.toString());
                }
                // Otherwise select the first one
                else if (formattedVobs.length > 0) {
                    setSelectedVob(formattedVobs[0].id.toString());
                }
            }
        } else if (vob && vob.vobId) {
            // Fallback to current VOB if patientVobList isn't populated
            setVobsList([{
                id: vob.vobId,
                name: getVobDisplayText(vob)
            }]);

            if (!isManualVobChange.current) {
                setSelectedVob(vob.vobId.toString());
            }
        }
    }, [patientVobList, vob, estimate, getVobDisplayText]);

    // Handle Facility on Estimate only for SelfPay
    const handleFacilityChange = async (facilityId: number) => {
        setSelectedFacility(facilityId);

        let updatedEstimate: Estimate = {
            ...Utils.deepClone(estimate),
            facilityId: facilityId,
            isSelfPay: isSelfPay,
            isPrivatePay: isPrivatePay || !!estimate?.isPrivatePay,
        };
        dispatch(setSelectedEstimate(updatedEstimate));

        const selectedFacility: Facility = {
            facilityId: facilityId
        }

        let selectedPayor: Payor;
        let selectedPlan: Plan;

        if (isPrivatePay || isSelfPay) {
            const sssconfig: any = {
                paramId: paramId,
                masterListPayers: payers,
                facilityId: facilityId,
            };
            const facilityPayors = await dispatch(getEstimatorFacilityPayers(sssconfig));
            const selfPayPayor = getSelfPayPayer(facilityPayors);
            const planDetails = getPlanDetails(selfPayPayor, facilityPayors);

            selectedPayor = {
                payorId: selfPayPayor?.cfgPayorId
            } as Payor;

            selectedPlan = {
                payorPlanId: planDetails?.payorPlanId
            } as Plan;
        } else {
            selectedPayor = {
                payorId: selectedPatientCurrentInsurance?.payorId
            } as Payor;

            selectedPlan = {
                payorPlanId: selectedPatientCurrentInsurance?.payorPlanId
            } as Plan;
        }

        // call the rateasPayor w/ new facility
        await loadAndSetRateAsPayorPlan(
            { clientId: currentClientId } as Client,
            selectedFacility,
            dispatch,
            state.reduxMasterPayors,
            selectedPayor,
            selectedPlan,
            state.reduxRateAsPayorMap,
            estimate!,
            rateAsPayorPlan,
            vob!,
            updatedEstimate!,
            vob?.vobId
        );
    };


    // Handle estimate selection change
    const handleEstimateChange = (event: any) => {
        const newEstimateId = event.target.value;

        // Navigate to the selected estimate
        if (newEstimateId && newEstimateId !== estimateId) {
            // Clear the encounter before fetching the new estimate
            dispatch(clearEncounter());
            // Clear selected VOB to maintain state consistency
            dispatch(clearSelectedVob());

            // Clear facility levels of care to prevent stale data from previous estimate
            dispatch(estimatorSlice.actions.setFacilityLevelsOfCareList(null));

            // Set loading flag
            setIsLoadingEstimate(true);

            // Fetch the selected estimate immediately to update the UI
            dispatch(
                loadSelectedEstimate({
                    paramId: paramId,
                    estimationId: Number(newEstimateId)
                })
            ).finally(() => {
                setIsLoadingEstimate(false);
            });

            // Update the URL using React Router's navigate
            navigate(`/patients/${selectedPatient.patientId}/estimate/${newEstimateId}`);
        }
    };

    const handleVobChange = async (event: any) => {
        const newVobId = event.target.value;

        let updatedEstimate: Estimate | null = estimate;

        isManualVobChange.current = true;

        setSelectedVob(newVobId);

        // dispatch(estimatorSlice.actions.setRateAsPayorPlan(null));

        // After initial load, update the current estimate to be associated with the new VOB
        if (newVobId && newVobId !== vob?.vobId?.toString() && !isInitialLoad.current && estimate) {
            try {
                // Update the estimate to be associated with the new VOB
                const putEstimateBody = {
                    ..._.omit(estimate, [
                        'estimateId',
                        'createUserId',
                        'createDt',
                        'lastUpdateUserId',
                        'lastUpdateDt',
                        'summary',
                        'crossOverSummary',
                        'priorCareSummary',
                    ]),
                    patientId: selectedPatient.patientId,
                    vobId: Number(newVobId), // Associate with the new VOB
                    description: normalizeDescription(estimate?.description, estimate.isPrivatePay || isPrivatePay, isSelfPay),
                    crossoverSelection: 0, // Default to "Before Crossover"
                    isPlanYearCrossover: estimate.isPlanYearCrossover || false, // Preserve existing value or default to false
                    advisorPatientId: estimate.advisorPatientId || 1,
                    ...(rateAsPayorPlan != null ? { rateAsPayorPlan } : {}),
                    isSelfPay: isSelfPay,
                    isPrivatePay: estimate.isPrivatePay || isPrivatePay
                };
                updatedEstimate = putEstimateBody;
                await dispatch(
                    (isSelfPay || isPrivatePay)
                        ? saveSelectedEstimateSelfPay({ estimateId: estimate.estimateId, estimate: putEstimateBody })
                        : saveSelectedEstimate({ estimateId: estimate.estimateId, estimate: putEstimateBody })
                );

                // Refresh the saved estimates list to show updated description
                await dispatch(loadSavedEstimatesListv3({
                    paramId: paramId,
                    patientId: Number(patientId),
                }));

                dispatch(showStatus(`Estimate ${estimate.estimateId} associated with new VOB`));
            } catch (error) {
                console.error('Error updating estimate with new VOB:', error);
                dispatch(showErrorStatus('Error associating estimate with new VOB. Please try again.'));
            }
        }

        // Load the new VOB data regardless of initial load status
        if (newVobId && newVobId !== vob?.vobId?.toString()) {
            const fetchVobAndSetRateAsPayorPlan = async () => {
                try {
                    // First fetch the VOB
                    const vobResponse = await dispatch(loadSelectedVob({vobId: newVobId}));
                    const updatedVob: Vob = vobResponse.payload;
                    const existingVob = Utils.deepClone(vob)

                    // Then fetch facility payers and set rateAsPayorPlan
                    if (updatedVob.facility) {
                        // Use the utility function to load and set the rateAsPayorPlan
                        await loadAndSetRateAsPayorPlan(
                            updatedVob.client,
                            updatedVob.facility,
                            dispatch,
                            state.reduxMasterPayors,
                            updatedVob.payor,
                            updatedVob.plan,
                            state.reduxRateAsPayorMap,
                            estimate!,
                            rateAsPayorPlan,
                            existingVob!,
                            updatedEstimate!,
                            newVobId
                        );
                    }


                    isManualVobChange.current = false;
                } catch (error) {
                    console.error('Error fetching VOB or setting rateAsPayorPlan:', error);
                    dispatch(showErrorStatus('Error loading VOB data. Please try again.'));

                    isManualVobChange.current = false;
                }
            };

            fetchVobAndSetRateAsPayorPlan();
        } else {

            isManualVobChange.current = false;
        }
    };

    const handleNewEstimate = () => {
        hasAutoSelectedFirstEstimate.current = true;
        navigate(`/patients/${selectedPatient.patientId}/estimate`, { replace: true });
        setIsPrivatePay(false);
        dispatch(clearSelectedEstimate());
    };

    // Prepare for attaching estimate to IOC
    const prepareAttachToIoc = () => {
        // Validate estimate before attaching estimate to IOC
        if (!estimate) {
            dispatch(showErrorStatus('No estimate available for IOC creation'));
            return;
        }
        if (isSaving) return;

        const validationContext = {
            estimate,
            selectedPatientCurrentInsurance,
            selectedEncounter,
            vob,
            rateAsPayorPlan,
            payersMap,
            facilityLevelsOfCareList
        };

        const validationResult = EstimateValidationService.validateEstimateForIOC(validationContext, !!estimate?.patientEncounterId);

        // Show validation errors and skip attaching if errors exist
        if (validationResult.errors.length > 0) {
            validationResult.errors.forEach(error => {
                dispatch(showErrorStatus(error));
            });
            return; // Validation failed
        }

        // Show warnings but allow attaching to IOC
        if (validationResult.warnings.length > 0) {
            validationResult.warnings.forEach(warning => {
                dispatch(showErrorStatus(warning));
            });
        }

        setIsSaving(true);
        // Only clear/fetch when the estimate is linked to a different encounter.
        if (
            estimate?.patientEncounterId &&
            (!selectedEncounter ||
                Number(selectedEncounter.patientEncounterId) !== Number(estimate.patientEncounterId))
        ) {
            dispatch(clearEncounter());

            patientService.getPatientInstanceOfCare({
                patientId: selectedPatient.patientId,
                encounterId: estimate.patientEncounterId
            }).then(res => {
                dispatch(setSelectedEncounter(res.entity));
                handleAttachToIoc(estimate);
            }).catch(error => {
                console.error('Error fetching patient encounter:', error);
                dispatch(showErrorStatus('Error loading patient encounter data.'));
                setIsSaving(false);
            });
        } else {
            handleAttachToIoc(estimate);
        }
    };

    useEffect(() => {
        const loadLatestNotManagedIOC = async () => {
            if (!selectedEncounter || !selectedEncounter.patientEncounterId) {
                if (estimate?.patientEncounterId) {
                    return;
                }

                if (isLoadingIOCRef.current) {
                    return;
                }

                const patientId = selectedPatient?.patientId;

                if (!patientId) {
                    return;
                }
                if (lastLoadedPatientIdRef.current === patientId) {
                    return;
                }

                isLoadingIOCRef.current = true;
                lastLoadedPatientIdRef.current = patientId;

                try {
                    const response = await patientService.getPatientInstancesOfCare({
                        patientId: patientId,
                        limit: 100,
                        offset: 0,
                    });

                    if (response.hasErrors) {
                        console.error('Error fetching patient encounters:', response.errorMessage);
                        isLoadingIOCRef.current = false;
                        lastLoadedPatientIdRef.current = undefined;
                        return;
                    }

                    const encounters = response.entity as PatientEncounter[];

                    const encountersWorkflow2 = encounters.filter(
                        (encounter) => encounter.workflow?.workflowId === 2
                    );

                    if (encountersWorkflow2.length > 0) {
                        const latestWorkflow2Ioc = [...encountersWorkflow2].sort((a, b) => {
                            const dateA = new Date(a.instanceCreateDt || 0).getTime();
                            const dateB = new Date(b.instanceCreateDt || 0).getTime();
                            if (dateB !== dateA) {
                                return dateB - dateA;
                            }
                            return (b.patientEncounterId || 0) - (a.patientEncounterId || 0);
                        })[0];

                        await dispatch(getInstanceOfCare({
                            patientId: latestWorkflow2Ioc.patientId,
                            encounterId: latestWorkflow2Ioc.patientEncounterId,
                        }));
                    }
                } catch (error) {
                    console.error('Error loading latest workflow 2 IOC:', error);
                    lastLoadedPatientIdRef.current = undefined;
                } finally {
                    isLoadingIOCRef.current = false;
                }
            }
        };

        loadLatestNotManagedIOC();
    }, [selectedPatient?.patientId, selectedEncounter?.patientEncounterId, estimate?.patientEncounterId, dispatch]);

    // Fetch the patient encounter if estimate has patientEncounterId but selectedEncounter is empty
    useEffect(() => {
        const fetchPatientEncounter = async () => {
            if (
                estimate?.patientEncounterId &&
                (!selectedEncounter || Number(selectedEncounter.patientEncounterId) !== Number(estimate.patientEncounterId))
            ) {
                try {
                    await dispatch(getInstanceOfCare({
                        patientId: selectedPatient.patientId,
                        encounterId: Number(estimate.patientEncounterId),
                    }));
                } catch (error) {
                    console.error('Error fetching patient encounter:', error);
                    dispatch(showErrorStatus('Error loading patient encounter data.'));
                }
            }
        };

        if (selectedPatient?.patientId && estimate?.patientEncounterId && !isLoadingEstimate && !estimatorLoadingState?.selectedEstimate) {
            fetchPatientEncounter();
        }
    }, [estimate?.patientEncounterId, selectedEncounter?.patientEncounterId, selectedPatient?.patientId, dispatch, isLoadingEstimate, estimatorLoadingState?.selectedEstimate]);
    
    // Navigate to new estimate URL when a new estimate is created
    useEffect(() => {
        if (
            estimate?.quoteMethod === QuoteMethod.MANUAL ||
            estimate?.quoteMethod === QuoteMethod.SCA
        ) {
            setDoesLOCSummaryValNeedUpdating(true);
        }
        if (estimate?.estimateId && selectedPatient?.patientId && !estimateId) {
            console.log('New estimate created, navigating to include estimate ID in URL:', estimate.estimateId);
            navigate(`/patients/${selectedPatient.patientId}/estimate/${estimate.estimateId}`, { replace: true });
        }
    }, [estimate?.estimateId, selectedPatient?.patientId, estimateId, navigate]);


    const handleCopyEstimate = async () => {
        if (!estimate) {
            dispatch(showErrorStatus('No estimate to copy'));
            return;
        }

        try {
            setIsCopying(true);

            const createdDate = admissionsAdvisorUtils.formatDateTime(new Date());
            const levelsOfCare = estimate.facilityLevelOfCare
                ?.map((loc) => loc.facilityLevelOfCareName)
                .join(', ');
            const estimateDescription = `${levelsOfCare} - ${createdDate}`;

            const estimateCopy = {
                vobId: estimate.vobId,
                clientId: estimate.clientId,
                facilityId: estimate.facilityId,
                advisorPatientId: estimate.advisorPatientId,
                patientId: selectedPatient.patientId,
                ...((selectedEncounter?.patientEncounterId || estimate.patientEncounterId) && {
                    patientEncounterId: selectedEncounter?.patientEncounterId || estimate.patientEncounterId
                }),
                description: estimateDescription,
                quoteMethod: estimate.quoteMethod,
                anticipatedAdmitDate: estimate.anticipatedAdmitDate,
                facilityLevelOfCare: estimate.facilityLevelOfCare?.map(loc => {
                    const { totalCharge, rate, ...cleanLoc } = loc as any;
                    return cleanLoc;
                }) || [],
                isPlanYearCrossover: estimate.isPlanYearCrossover || false,
                summarySelection: estimate.summarySelection,
                crossoverSelection: estimate.crossoverSelection,
                isActive: true,
                rateAsPayorPlan: rateAsPayorPlan,
                isSelfPay: isSelfPay,
                isPrivatePay: estimate.isPrivatePay,
                ...(estimate.priorCare && { priorCare: estimate.priorCare }),
                ...(estimate.financialAssistance && { financialAssistance: estimate.financialAssistance }),
            };


            const createAction = (isSelfPay || estimate.isPrivatePay) ? createSelectedEstimateSelfPay : createSelectedEstimate;
            const response = await dispatch(createAction(estimateCopy));

            if (response.meta.requestStatus === 'fulfilled') {
                const newEstimateId = response.payload?.estimateId;

                if (newEstimateId) {
                    // refresh list
                    await dispatch(loadSavedEstimatesListv3({
                        paramId: paramId,
                        patientId: Number(selectedPatient?.patientId),
                    }));

                    await dispatch(loadSelectedEstimate({
                        paramId: paramId,
                        estimationId: newEstimateId
                    }));

                    // navigate to new estimate
                    navigate(`/patients/${selectedPatient?.patientId}/estimate/${newEstimateId}`);
                } else {
                    dispatch(showErrorStatus('Failed to get new estimate ID'));
                }
            } else {
                dispatch(showErrorStatus('Failed to copy estimate'));
            }
        } catch (error) {
            console.error('Error copying estimate:', error);
            dispatch(showErrorStatus(`Error copying estimate: ${error}`));
        } finally {
            setIsCopying(false);
        }
    };

    const getNewNoneWorkflow = () =>
        workFlowStatus.preconvert.find(
            (w) =>
                w.workflowStatus.workflowStatusName === 'New' &&
                w.workflowSubStatus.workflowSubStatusName === 'None'
        );

    const savePreviouslyUnmanagedIocWorkflowStatus = async ({
        encounterId,
        workflowStatusId,
    }: {
        encounterId?: number;
        workflowStatusId?: number;
    }) => {
        if (workflowStatusId !== 20 || !encounterId) {
            return;
        }

        const newNoneWorkflow = getNewNoneWorkflow();

        if (!newNoneWorkflow?.workflowId) {
            throw new Error('New None Workflow not found');
        }

        const workflowToSave: Omit<Workflow, 'workflowName'> = {
            workflowId: newNoneWorkflow.workflowId,
            workflowStatus: {
                workflowStatusId: newNoneWorkflow.workflowStatus.workflowStatusId,
                workflowStatusDesc: newNoneWorkflow.workflowStatus.workflowStatusName || '',
            },
            workflowSubStatus: {
                workflowSubStatusId: newNoneWorkflow.workflowSubStatus.workflowSubStatusId,
                workflowSubStatusDesc: newNoneWorkflow.workflowSubStatus.workflowSubStatusName || '',
            },
        };

        await dispatch(savePatientStatus({
            workFlow: workflowToSave as Workflow,
            encounterId,
            patientId: Number(selectedPatient.patientId),
        })).unwrap();
    };

    const syncEstimateEncounterWorkflowFromApi = async (
        encounterId: number,
        attachToIoc?: boolean,
    ) => {
        if (!selectedPatient?.patientId) {
            throw new Error('Missing patientId');
        }

        const freshResponse = await patientService.getPatientInstanceOfCare({
            patientId: selectedPatient.patientId,
            encounterId,
        });
        if (freshResponse.hasErrors) {
            throw new Error(freshResponse.errorMessage || 'Failed to fetch patient encounter');
        }

        let encounter = freshResponse.entity;
        if (
            attachToIoc &&
            Number(encounter?.workflow?.workflowStatus?.workflowStatusId) === 20
        ) {
            await savePreviouslyUnmanagedIocWorkflowStatus({
                encounterId,
                workflowStatusId: 20,
            });

            const refreshedResponse = await patientService.getPatientInstanceOfCare({
                patientId: selectedPatient.patientId,
                encounterId,
            });
            if (!refreshedResponse.hasErrors) {
                encounter = refreshedResponse.entity;
            }
        }

        dispatch(setSelectedEncounter(encounter));
        return encounter;
    };

    const sendIocToMobileQueue = async (
        encounterId: number,
        workflowStatusId?: number
    ): Promise<PatientEncounter | undefined> => {
        if (!encounterId) {
            return;
        }

        const currentWorkflowStatusId = Number(
            workflowStatusId ?? selectedEncounter?.workflow?.workflowStatus?.workflowStatusId
        );
        const isIOCPreviouslyUnmanaged = currentWorkflowStatusId === 20;
        if (!isIOCPreviouslyUnmanaged) {
            return;
        }

        const queueResponse = await patientService.sendInstanceOfCareToMobileQueue(encounterId);
        if (queueResponse.hasErrors) {
            dispatch(
                showErrorStatus(`Error sending Unmanaged IOC to Mobile Queue: ${queueResponse.errorMessage}`)
            );
        }
        if (queueResponse.entity?.failureMessages?.length === 0) {
            const updatedIoc = queueResponse.entity?.patientEncounter;
            dispatch(setSelectedEncounter(updatedIoc));
            return updatedIoc;
        }
    };

    const buildIocSyncFields = (estimateToSync: Estimate) => {
        const pfrSummary: any = estimateToSync?.summary;
        const pfrAmt = pfrSummary?.totalPFR ?? 0;
        const timingRiskValue = createEstimatorFormik.values.timingRisk;
        const payorRiskValue = resolvePayorRiskId();
        const interactionIntentValue = createEstimatorFormik.values.interactionType;
        const foundTimingRisk = timingRisk.find(
            (t) => t.timingRiskId === Number(timingRiskValue)
        );
        const foundPayorRisk = payorRisk.find(
            (p) => p.payorRiskId === Number(payorRiskValue)
        );
        const levelsOfCare = estimateToSync?.facilityLevelOfCare
            ?.map((loc) => loc.facilityLevelOfCareName)
            .join(', ');
        const truncLevelsOfCare =
            levelsOfCare && levelsOfCare.length > 128
                ? levelsOfCare.slice(0, 128)
                : levelsOfCare;
        const totalSurchargeRate = admissionsAdvisorUtils.newEstimateCalculateTotalSurchargeRate(
            estimateToSync?.facilityLevelOfCare
        );

        return {
            pfrAmt,
            timingRiskValue,
            payorRiskValue,
            interactionIntentValue,
            foundTimingRisk,
            foundPayorRisk,
            truncLevelsOfCare,
            totalSurchargeRate,
        };
    };

    // Update all estimates without an IOC and link them to the new IOC
    const updateAllEstimatesWithoutIOC = async (
        patientEncounterId: number,
        excludeEstimateId?: number
    ) => {
        if (!savedEstimations || !Array.isArray(savedEstimations)) {
            return;
        }

        const estimatesWithoutIOC = savedEstimations.filter((est: any) => {
            const estimateBody = est.estimateBody || est;
            return !estimateBody.patientEncounterId && est.pfrEstimateId;
        });

        if (estimatesWithoutIOC.length === 0) {
            return;
        }

        for (const est of estimatesWithoutIOC) {
            try {
                const estAny = est as any;
                const estimateBody = estAny.estimateBody || est;
                const estimateId = estAny.pfrEstimateId || estAny.estimateId;

                if (
                    excludeEstimateId != null &&
                    Number(estimateId) === Number(excludeEstimateId)
                ) {
                    continue;
                }

                if (!estimateId || !vob) {
                    continue;
                }

                const facilityId =
                    estimateBody.facilityId ?? vob.facility?.facilityId;
                const updateBody = admissionsAdvisorUtils.mapToNewEstimate(
                    vob.vobId,
                    vob.client?.clientId!,
                    facilityId!,
                    estimateBody,
                    estimateBody.advisorPatientId || selectedPatient?.patientId || 0,
                    patientEncounterId.toString()
                );
                updateBody.patientId = selectedPatient?.patientId;
                if (rateAsPayorPlan) {
                    updateBody.rateAsPayorPlan = rateAsPayorPlan;
                }

                const isSelfPayOrPrivatePayEst = estimateBody.isSelfPay || estimateBody.isPrivatePay;

                await dispatch(
                    isSelfPayOrPrivatePayEst
                        ? saveSelectedEstimateSelfPay({ estimateId: estimateId, estimate: updateBody })
                        : saveSelectedEstimate({ estimateId: estimateId, estimate: updateBody })
                );
            } catch (error) {
                const estAny = est as any;
                console.error(
                    `Error updating estimate ${estAny.pfrEstimateId || estAny.estimateId}:`,
                    error
                );
            }
        }
    };

    const handleIocSave = async (estimateToSync: Estimate, attachToIoc?: boolean): Promise<boolean> => {
        // Only update IOC that points at this estimate (except when attaching to IOC)
        if (!attachToIoc && !isIocLinkedToEstimate) {
            return false;
        }

        // Converted IOCs are locked
        if (selectedEncounter?.workflow?.workflowId === 3) {
            return false;
        }

        if (!createEstimatorFormik.values.timingRisk) {
            await createEstimatorFormik.setFieldTouched('timingRisk', true, false);
            createEstimatorFormik.setFieldError('timingRisk', 'Required');
            throw new Error('IOC validation failed');
        }

        const {
            pfrAmt,
            timingRiskValue,
            payorRiskValue,
            interactionIntentValue,
            foundTimingRisk,
            foundPayorRisk,
            truncLevelsOfCare,
            totalSurchargeRate,
        } = buildIocSyncFields(estimateToSync);

        const timingRiskName = foundTimingRisk?.timingRiskName;
        const payorRiskName = foundPayorRisk?.payorRiskName;
        const workflowStatusId = Number(selectedEncounter?.workflow?.workflowStatus?.workflowStatusId);

        let riskClassId: number | undefined;
        let riskClassName: string | undefined;
        let updatedIoc: PatientEncounter | undefined;
        let encounterId = Number(estimateToSync.patientEncounterId);

        // Create IOC if attaching to IOC and estimate's patientEncounterId is not set
        if (attachToIoc && !encounterId) {
            const isIOCPreviouslyUnmanaged = Number(selectedEncounter?.workflow?.workflowStatus?.workflowStatusId) === 20;
            const workflow = isIOCPreviouslyUnmanaged ? getNewNoneWorkflow() : undefined;
    
            const iocConfig: IocConfig = {
                paramId: 0,
                patientId: selectedPatient?.patientId,
                clientId: estimateToSync?.clientId! as number,
                facilityId: estimateToSync?.facilityId as number,
                pfrAmt,
                pfrEstimateId: estimateToSync?.estimateId as number,
                timingRisk: foundTimingRisk,
                payorRisk: foundPayorRisk,
                finClearanceStatus: 'New',
                levelOfCare: truncLevelsOfCare,
                totalSurchargeRate,
                ...(workflow && { workflow }),
            };
    
            const iocResponse = await dispatch(createPatientIoc(iocConfig));
            updatedIoc = iocResponse?.payload;
            if (!updatedIoc?.patientEncounterId) {
                throw new Error('Failed to create Instance of Care');
            }
    
            encounterId = Number(updatedIoc.patientEncounterId);
            riskClassName = updatedIoc.riskClass?.riskClassName;
            dispatch(setSelectedEncounter(updatedIoc));
            // Replace empty placeholder encounter (id 0) with the newly created IOC
            if (selectedPatientEncounters && selectedPatientEncounters.length === 1 && selectedPatientEncounters[0].patientEncounterId === 0 && selectedPatientEncounters[0].patientId === 0) {
                dispatch(setPatientEncounters([{...updatedIoc}]));
            }

            // update estimate with the new patientEncounterId
            const putEstimateBody = {
                ..._.omit(estimateToSync, [
                    'estimateId',
                    'createUserId',
                    'createDt',
                    'lastUpdateUserId',
                    'lastUpdateDt',
                    'summary',
                    'crossOverSummary',
                    'priorCareSummary',
                ]),
                patientId: selectedPatient.patientId,
                patientEncounterId: updatedIoc.patientEncounterId,
                vobId: vob?.vobId!,
                advisorPatientId: estimateToSync?.advisorPatientId || 1,
                facilityId: estimateToSync.facilityId,
                rateAsPayorPlan: rateAsPayorPlan,
                isSelfPay: isSelfPay,
                isPrivatePay: isPrivatePay,
                description: normalizeDescription(
                    estimateToSync?.description,
                    isPrivatePay,
                    isSelfPay
                ),
            };
    
            const savedEstimate = await dispatch(
                (isSelfPay || isPrivatePay || estimateToSync.isPrivatePay)
                    ? saveSelectedEstimateSelfPay({estimateId: estimateToSync.estimateId, estimate: putEstimateBody})
                    : saveSelectedEstimate({estimateId: estimateToSync.estimateId, estimate: putEstimateBody})
            ).unwrap();

            // update all estimates without an IOC and link them to the new IOC
            if (updatedIoc?.patientEncounterId) {
                await updateAllEstimatesWithoutIOC(updatedIoc.patientEncounterId, Number(estimateToSync?.estimateId));
            }

            // restore selected estimate after updating other estimates
            dispatch(setSelectedEstimate(savedEstimate));
        } else {
            // Get risk class ID and name for the estimate if it exists
            if (timingRiskName && payorRiskName && estimateToSync?.facilityId) {
                const riskClassResponse = await patientService.getPatientEncounterRiskClass(
                    Number(estimateToSync.facilityId),
                    false,
                    timingRiskName,
                    payorRiskName,
                    pfrAmt
                );

                if (!riskClassResponse.hasErrors && riskClassResponse.entity?.riskClassId) {
                    riskClassId = riskClassResponse.entity.riskClassId;
                    riskClassName = riskClassResponse.entity.riskClassName;
                }
            }

            const iocPartialObject = {
                timingRiskId: Number(timingRiskValue),
                payorRiskId: Number(payorRiskValue),
                pfrEstimateId: estimateToSync.estimateId,
                pfrAmt,
                facilityId: estimateToSync?.facilityId,
                totalSurchargeRate,
                admissionDt: admissionDate
                    ? new Date(admissionDate).toISOString()
                    : undefined,
                ...(truncLevelsOfCare && { levelOfCare: truncLevelsOfCare }),
                ...(riskClassId && { riskClassId }),
            };

            const saveIocResponse = await patientService.saveIOCWithPartialObject(
                iocPartialObject,
                encounterId
            );
            if (saveIocResponse.hasErrors) {
                throw new Error(saveIocResponse.errorMessage || 'Failed to update patient encounter');
            }
        }

        // refresh the payment program
        await patientRecordUtils.updatePaymentProgram(
            dispatch, 
            updatedIoc ?? selectedEncounter
        )
        
        // generate the update comment for the IOC
        const iocUpdateComment = [
            interactionIntentValue && `Interaction Intent: ${interactionIntentValue || ''}`,
            `Timing Risk: ${timingRiskName ?? ''}`,
            `Payor Risk: ${payorRiskName ?? ''}`,
            `PFR Estimate ID: ${estimateToSync.estimateId ?? ''}`,
            `PFR Amount: ${formatNumberToUSD(pfrAmt)}`,
            `Facility: ${currentFacility?.facilityName ?? estimateToSync.facilityId ?? ''}`,
            `Total Surcharge Amount: ${formatNumberToUSD(estimateToSync?.summary?.totalSurcharges)}`,
            `Admission Date: ${
                admissionDate
                    ? new Date(admissionDate).toLocaleDateString('en-US')
                    : ''
            }`,
            truncLevelsOfCare && `Level of Care: ${truncLevelsOfCare}`,
            riskClassName != null && `${riskClassName}`,
        ]
            .filter(Boolean)
            .join('; ');

        let refreshedIoc: PatientEncounter | undefined;
        // When attaching to IOC and workflow is incomplete, transition to new/none workflow
        const updatedPatientIocWorkflow = syncEstimateEncounterWorkflowFromApi(encounterId, attachToIoc);
        [refreshedIoc] = await Promise.all([
            updatedPatientIocWorkflow,
            patientRecordUtils.createNotes(
                dispatch,
                { noteText: iocUpdateComment },
                { patientEncounterId: encounterId },
                selectedPatient
            ),
        ]);
        if (!refreshedIoc) {
            throw new Error('Failed to refresh Instance of Care');
        }

        // send the IOC to the mobile queue
        if (attachToIoc) {
            refreshedIoc = (await sendIocToMobileQueue(encounterId, workflowStatusId)) ?? refreshedIoc;
        } 

        // send integration updates for the IOC
        const clientItem = allClients?.get(Number(estimateToSync.clientId));
        const clientCrm = clientItem?.clientCrm || [];

        await patientRecordUtils.handleIntegrationUpdates(
            refreshedIoc,
            clientCrm,
            selectedPatient
        )
        return true;
    };

    const handleAttachToIoc = async (estimateToSync: Estimate) => {
        try {
            const didSucceed = await handleIocSave(estimateToSync, true);
            if (didSucceed) {
                if (selectedPatient?.patientId) {
                    await dispatch(
                        loadSavedEstimatesListv3({
                            paramId,
                            patientId: Number(selectedPatient.patientId),
                        })
                    );
                }
                dispatch(
                    showStatus('Instance of Care saved successfully')
                );
            } else {
                dispatch(
                    showErrorStatus('Unable to attach estimate to Instance of Care.')
                );
            }
        } catch (error) {
            console.error('Error saving Instance of Care:', error);
            dispatch(showErrorStatus('Error saving Instance of Care. Please try again.'));
        } finally {
            setIsSaving(false);
        }
    };

    const handleSaveEstimate = async (privatePayStatus: boolean, hideSuccessMsg: boolean) => {
        if ((!vob || !vob.vobId) && (!isSelfPay && !privatePayStatus)) {
            dispatch(showErrorStatus('Cannot save estimate without a valid VOB. Please ensure a VOB is selected.'));
            return;
        }

        if (!estimate) {
            dispatch(showErrorStatus('No estimate to save. Please create an estimate first.'));
            return;
        }

        // Validate estimate before saving
        const validationContext = {
            estimate,
            selectedPatientCurrentInsurance,
            selectedEncounter,
            vob,
            rateAsPayorPlan,
            payersMap,
            facilityLevelsOfCareList
        };

        const validationResult = EstimateValidationService.validateEstimateOnSave(validationContext);

        // Show validation errors and block save if errors exist
        if (validationResult.errors.length > 0) {
            validationResult.errors.forEach(error => {
                dispatch(showErrorStatus(error));
            });
            return;
        }

        // Show warnings but allow save to continue
        if (validationResult.warnings.length > 0) {
            validationResult.warnings.forEach(warning => {
                dispatch(showErrorStatus(warning));
            });
        }

        setIsSaving(true);
        let estimateSaveSucceeded = false;
        try {
            const resolvedFacilityId =
                (isSelfPay || privatePayStatus) &&
                selectedFacility !== '' &&
                selectedFacility != null
                    ? Number(selectedFacility)
                    : estimate.facilityId;

            const putEstimateBody = {
                ..._.omit(estimate, [
                    'estimateId',
                    'createUserId',
                    'createDt',
                    'lastUpdateUserId',
                    'lastUpdateDt',
                    'summary',
                    'crossOverSummary',
                    'priorCareSummary',
                ]),
                patientId: selectedPatient.patientId,
                vobId: vob?.vobId!,
                advisorPatientId: estimate?.advisorPatientId || 1,
                facilityId: resolvedFacilityId,
                rateAsPayorPlan: rateAsPayorPlan,
                isSelfPay: isSelfPay,
                isPrivatePay: privatePayStatus,
                description: normalizeDescription(estimate?.description, privatePayStatus, isSelfPay)
            };

            await dispatch(
                (isSelfPay || privatePayStatus)
                    ? saveSelectedEstimateSelfPay({ estimateId: estimate.estimateId, estimate: putEstimateBody })
                    : saveSelectedEstimate({ estimateId: estimate.estimateId, estimate: putEstimateBody })
            ).unwrap(); // Unwrap so estimate failure skips success toast / later steps

            // Refresh the saved estimates list to show updated description
            await dispatch(loadSavedEstimatesListv3({
                paramId: paramId,
                patientId: Number(patientId),
            }));

            estimateSaveSucceeded = true;
            const didUpdateIoc = await handleIocSave({
                ...estimate,
                ...putEstimateBody,
                estimateId: estimate.estimateId,
                summary: estimate.summary,
            } as Estimate);

            if (!hideSuccessMsg) {
                dispatch(
                    showStatus(
                        didUpdateIoc
                            ? 'Estimate and Instance of Care saved successfully'
                            : 'Estimate saved successfully'
                    )
                );
            }
        } catch (error) {
            if (estimateSaveSucceeded) {
                console.error('Error saving Instance of Care:', error);
                dispatch(showErrorStatus('Estimate saved successfully, but error saving Instance of Care.'
                ));
            } else {
                console.error('Error saving estimate:', error);
                dispatch(showErrorStatus('Error saving estimate. Please try again.'));
            }
        } finally {
            setIsSaving(false);
        }
    };

    const handlePrivatePay = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (isPrivatePaySwitching) return;
        const privatePayStatus = event.target.checked;
        setIsPrivatePay(privatePayStatus);
        setIsPrivatePaySwitching(true);

        const resolvedFacilityId = estimate?.facilityId ?? vob?.facility?.facilityId ?? (selectedFacility !== '' && selectedFacility != null ? Number(selectedFacility) : undefined);
        const resolvedClientId = estimate?.clientId ?? vob?.client?.clientId ?? selectedPatient?.clientId;
        let updatedEstimate: Estimate = {
            ...Utils.deepClone(estimate),
            isPrivatePay: privatePayStatus,
            ...(resolvedFacilityId != null && { facilityId: resolvedFacilityId }),
            ...(resolvedClientId != null && { clientId: Number(resolvedClientId) }),
        };
        const desc = updatedEstimate.description || "";

        try {
            if (privatePayStatus) {
                if (!resolvedFacilityId) {
                    dispatch(showErrorStatus('Cannot enable Private Pay without a facility.'));
                    return;
                }
                if (!desc.startsWith("Private Pay - ")) {
                    updatedEstimate.description = `Private Pay - ${desc}`;
                }
                dispatch(setSelectedEstimate(updatedEstimate));

                const sssconfig: any = {
                    paramId: paramId,
                    masterListPayers: payers,
                    facilityId: resolvedFacilityId,
                };
                const facilityPayors = await dispatch(getEstimatorFacilityPayers(sssconfig));
                const selfPayPayor = getSelfPayPayer(facilityPayors);
                const selectedPlan = getPlanDetails(selfPayPayor, facilityPayors);
                let updatedPatientCurrentInsurance = {
                    ...selectedPatientCurrentInsurance,
                    payorId: selfPayPayor?.cfgPayorId,
                    payorPlanId: selectedPlan?.payorPlanId,
                };

                const loadAndSetRateAsPayorPlanAdapter = async (
                    facility: any,
                    dispatch: Dispatch<any>,
                    payers: any,
                    payor: Payor,
                    plan: Plan
                ): Promise<void> => {
                    const clientId = resolvedClientId ? Number(resolvedClientId) : 0;
                    const clientObj = { clientId } as Client;
                    const targetClient = allClients.get(Number(clientId));
                    // Private Pay use the facility already on the estimate / form.
                    const facilityIdForRate = Number(
                        updatedEstimate.facilityId ?? resolvedFacilityId ?? facility?.facilityId
                    );
                    const facilityFromClient = targetClient?.clientFacilities?.find(
                        (f: any) => f.facilityId === facilityIdForRate
                    );
                    const estimateFacility: Facility = facilityFromClient
                        ? { facilityId: facilityFromClient.facilityId, facilityName: facilityFromClient.facilityName } as Facility
                        : { facilityId: facilityIdForRate } as Facility;
                    await loadAndSetRateAsPayorPlan(
                        clientObj,
                        estimateFacility,
                        dispatch,
                        state.reduxMasterPayors,
                        payor,
                        plan,
                        state.reduxRateAsPayorMap,
                        estimate ?? undefined,
                        rateAsPayorPlan ?? undefined,
                        vob ?? undefined,
                        updatedEstimate,
                        vob?.vobId
                    );
                };

                await loadAndSetRateAsWithoutVob({
                    selectedPatient,
                    patientDemographicResp: null,
                    selectedPatientCurrentInsurance: updatedPatientCurrentInsurance,
                    patientInsuranceResp: null,
                    allClientsMap: allClients,
                    dispatch,
                    payers,
                    loadAndSetRateAsPayorPlan: loadAndSetRateAsPayorPlanAdapter
                });
            } else {
                if (desc.startsWith("Private Pay - ")) {
                    updatedEstimate.description = desc.replace(/^Private Pay - /, "");
                }
                const vobIdKey = selectedVob || estimate?.vobId?.toString() || vob?.vobId?.toString();
                const insuranceVob = patientVobList?.find((pv: Vob) => pv.vobId?.toString() === vobIdKey) ?? (vob?.vobId ? vob : undefined);
                if (insuranceVob?.vobId) {
                    dispatch(setSelectedVobState(insuranceVob));
                }
                const vobToUse = insuranceVob || vob;
                const vobFacilityId = vobToUse?.facility?.facilityId;
                const estimateFacilityId = estimate?.facilityId;
                const facilityToUse = vobFacilityId || estimateFacilityId;
                if (vobFacilityId && vobFacilityId !== estimateFacilityId) {
                    updatedEstimate.facilityId = vobFacilityId;
                }
                if (vobToUse?.vobId != null) {
                    updatedEstimate.vobId = vobToUse.vobId as unknown as import('@finpay-estimation/estimation-types').Id;
                }

                let facilityObj: Facility;
                if (facilityToUse && currentClientId) {
                    const targetClient = allClients.get(Number(currentClientId));
                    const facilityFromClient = targetClient?.clientFacilities?.find(
                        (f: any) => f.facilityId === Number(facilityToUse)
                    );
                    facilityObj = facilityFromClient
                        ? { facilityId: facilityFromClient.facilityId, facilityName: facilityFromClient.facilityName } as Facility
                        : vobToUse?.facility || { facilityId: Number(facilityToUse) } as Facility;
                } else {
                    facilityObj = vobToUse?.facility || { facilityId: Number(facilityToUse) } as Facility;
                }
                const clientObj = vobToUse?.client || { clientId: currentClientId } as Client;
                // Keep Redux estimate in sync with checkbox immediately (avoids estimate.isPrivatePay || isPrivatePay stuck true during await).
                dispatch(setSelectedEstimate(updatedEstimate));
                await loadAndSetRateAsPayorPlan(
                    clientObj,
                    facilityObj,
                    dispatch,
                    state.reduxMasterPayors,
                    vobToUse?.payor || {} as Payor,
                    vobToUse?.plan || {} as Plan,
                    state.reduxRateAsPayorMap,
                    estimate ?? undefined,
                    rateAsPayorPlan ?? undefined,
                    vobToUse!,
                    updatedEstimate,
                    vobToUse?.vobId
                );
                // After save + LOC sync, API may replace selectedEstimate; merge so isPrivatePay/description stay correct and LOCs stay server-updated.
                const latest = store.getState().estimatorContext.selectedEstimate;
                if (latest?.estimateId != null && latest.estimateId === updatedEstimate.estimateId) {
                    dispatch(
                        setSelectedEstimate({
                            ...latest,
                            isPrivatePay: false,
                            description: updatedEstimate.description,
                            vobId: updatedEstimate.vobId,
                            facilityId: updatedEstimate.facilityId,
                            clientId: updatedEstimate.clientId,
                        } as Estimate)
                    );
                } else {
                    dispatch(setSelectedEstimate(updatedEstimate));
                }
            }
        } finally {
            setIsPrivatePaySwitching(false);
        }
    };

    return (
        <>
            {isLoadingClients ? (
                <LoadingOverlay />
            ) : (
                <>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            padding: 24,
                            height: 'auto',
                            overflow: 'visible',
                            backgroundColor: '#F5F7F9',
                        }}
                        test-id="estimate-tab-container"
                    >
                        <Grid
                            container
                            justifyContent="space-between"
                            direction="row"
                            spacing={2}
                        >
                            <Grid item direction="column" xs={8} test-id="estimate-tab-left-column">
                                <Paper test-id="estimate-tab-details-panel">
                                    <Box
                                        style={{
                                            padding: '1.0em 1.0em 0.5em 1.0em',
                                            marginBottom: '0.5em',
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <Grid container spacing={2} direction="row">
                                            <Grid item xs={3}>
                                                <Typography
                                                    variant="caption"
                                                    style={{color: 'grey'}}
                                                    test-id="estimate-tab-client-label"
                                                >
                                                    Client
                                                </Typography>
                                                <Typography variant="h3" test-id="estimate-tab-client-value">
                                                    {currentClient?.clientName}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={4} container justifyContent="flex-end">
                                                <Grid item xs={12}>
                                                    {(isPrivatePay || isSelfPay) ? (
                                                        <Box width="100%">
                                                            <TextField
                                                                select
                                                                label={
                                                                    facilitiesLoading || (!selectedFacility && facilities.length === 0)
                                                                        ? "Loading..."
                                                                        : "Facility"
                                                                }
                                                                onBlur={
                                                                    createEstimatorFormik.handleBlur
                                                                }
                                                                name="facility"
                                                                value={selectedFacility || ""}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                                                    handleFacilityChange(Number(e.target.value))
                                                                }
                                                                disabled={facilitiesLoading || (facilities.length === 0 && !selectedFacility)}
                                                                error={Boolean(facilities.length === 0 && !facilitiesLoading)} // optional error handling
                                                                test-id="vob-facility-select"
                                                            >
                                                                {facilitiesLoading || (facilities.length === 0 && !selectedFacility) ? (
                                                                    <MenuItem disabled>Loading facilities...</MenuItem>
                                                                ) : (
                                                                    facilities.map((facility: any) => (
                                                                        <MenuItem key={facility.facilityId} value={facility.facilityId}>
                                                                            {facility.facilityName}
                                                                        </MenuItem>
                                                                    ))
                                                                )}
                                                            </TextField>
                                                        </Box>
                                                    ) : (
                                                        <>
                                                            <Typography
                                                                variant="caption"
                                                                style={{color: 'grey'}}
                                                                test-id="estimate-tab-facility-label"
                                                            >
                                                                Facility
                                                            </Typography>
                                                            <Typography variant="h3" test-id="estimate-tab-facility-value">
                                                                {currentFacility?.facilityName}
                                                            </Typography>
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={4} container justifyContent="flex-end">
                                                <Box width="100%">
                                                    <TextField
                                                        select={true}
                                                        label="Quote Method"
                                                        name="quoteMethod"
                                                        value={quoteMethodValueAsEnum}
                                                        onChange={(e: Event) => {
                                                            createEstimatorFormik.handleChange(
                                                                e
                                                            );
                                                            handleNewEstimateQuoteMethodChange(
                                                                e
                                                            );
                                                        }}
                                                        onBlur={
                                                            createEstimatorFormik.handleBlur
                                                        }
                                                        error={Boolean(
                                                            createEstimatorFormik
                                                                .touched.quoteMethod &&
                                                            createEstimatorFormik
                                                                .errors.quoteMethod
                                                        )}
                                                        disabled={
                                                            isDisabledAfterConvert
                                                        }
                                                        test-id="estimate-quote-method"
                                                    >
                                                        <MenuItem
                                                            value={QuoteMethod.AVGLOS}
                                                        >
                                                            Average Length of Stay
                                                        </MenuItem>
                                                        <MenuItem
                                                            value={QuoteMethod.RLOS}
                                                        >
                                                            Recommended Length of Stay
                                                        </MenuItem>
                                                        <MenuItem
                                                            value={QuoteMethod.MANUAL}
                                                        >
                                                            Manual
                                                        </MenuItem>
                                                        <MenuItem
                                                            value={QuoteMethod.SCA}
                                                        >
                                                            Single Case Agreement
                                                        </MenuItem>
                                                    </TextField>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <Box display="flex" gap={1}>
                                            <DialogActionButton
                                                isEnabled={true}
                                                savebuttonText="New"
                                                saveStatus={saveCallbackStatus.none}
                                                executeSave={handleNewEstimate}
                                                handleCallbackSave={() => {}}
                                                handleCallbackCancel={() => {}}
                                                showCancelButton={false}
                                                test-id="estimate-tab-new-estimate-button"
                                            />
                                            <Button
                                                test-id="estimate-tab-save-estimate-button-header"
                                                onClick={() => {
                                                    if (isDisabledAfterConvert) {
                                                        handleCopyEstimate();
                                                    } else {
                                                        handleSaveEstimate(isPrivatePay, false);
                                                    }
                                                }}
                                                disabled={!Boolean(estimate?.estimateId) || isSaving || isCopying}
                                                style={{
                                                    minWidth: 'fit-content',
                                                    whiteSpace: 'nowrap',
                                                    flexShrink: 0
                                                }}
                                            >
                                                {isCopying ? 'Copying...' : isSaving ? 'Saving...' : (isDisabledAfterConvert ? 'Copy' : 'Save')}
                                            </Button>
                                        </Box>
                                    </Box>

                                    {/* Estimate dropdown */}
                                    <Box
                                        style={{
                                            padding: '0.5em 1.0em 0 1.0em',
                                            marginBottom: '0.5em',
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Box sx={{ position: 'relative', width: '100%' }}>
                                                    {savedEstimatesLoading && (
                                                        <LinearProgress
                                                            sx={{
                                                                position: 'absolute',
                                                                left: 0,
                                                                top: -11,
                                                                zIndex: 1,
                                                                width: '100%'
                                                            }}
                                                        />
                                                    )}
                                                    <MuiTextField
                                                        select
                                                        fullWidth
                                                        variant="outlined"
                                                        label="Estimate"
                                                        name="estimate"
                                                        value={selectedEstimateValue}
                                                        onChange={handleEstimateChange}
                                                        onBlur={() => {}}
                                                        disabled={savedEstimatesLoading}
                                                        inputProps={
                                                            { 'test-id': 'estimate-tab-estimate-dropdown' } as React.HTMLAttributes<HTMLInputElement>
                                                        }
                                                        SelectProps={{
                                                            renderValue: (value) => {
                                                                const est = (savedEstimations as any[]).find(
                                                                    (e) =>
                                                                        e.pfrEstimateId?.toString() ===
                                                                        String(value)
                                                                );
                                                                if (!est) {
                                                                    return '';
                                                                }
                                                                const isCurrentIocLinkedEstimate =
                                                                    selectedEncounter?.pfrEstimateId != null &&
                                                                    Number(est.pfrEstimateId) ===
                                                                        Number(selectedEncounter.pfrEstimateId);
                                                                return (
                                                                    <span
                                                                        style={{
                                                                            fontWeight: isCurrentIocLinkedEstimate
                                                                                ? 'bold'
                                                                                : 'normal',
                                                                            color: isCurrentIocLinkedEstimate
                                                                                ? '#2E7D32'
                                                                                : 'inherit'
                                                                        }}
                                                                    >
                                                                        {est.estimateBody?.description ||
                                                                            `Estimate ${est.pfrEstimateId}`}
                                                                        {est.estimateBody?.patientEncounterId &&
                                                                            ` - IOC: ${est.estimateBody.patientEncounterId}`}
                                                                    </span>
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {savedEstimations.length > 0 &&
                                                            [...(savedEstimations as any[])].map((est) => {
                                                                const isCurrentIocLinkedEstimate =
                                                                    selectedEncounter?.pfrEstimateId != null &&
                                                                    Number(est.pfrEstimateId) ===
                                                                        Number(selectedEncounter.pfrEstimateId);
                                                                return (
                                                                    <MenuItem
                                                                        key={est.pfrEstimateId}
                                                                        value={est.pfrEstimateId?.toString()}
                                                                        style={{
                                                                            fontWeight: isCurrentIocLinkedEstimate
                                                                                ? 'bold'
                                                                                : 'normal',
                                                                            color: isCurrentIocLinkedEstimate
                                                                                ? '#2E7D32'
                                                                                : 'inherit'
                                                                        }}
                                                                    >
                                                                        {est.estimateBody?.description ||
                                                                            `Estimate ${est.pfrEstimateId}`}
                                                                        {est.estimateBody?.patientEncounterId &&
                                                                            ` - IOC: ${est.estimateBody.patientEncounterId}`}
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                    </MuiTextField>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    {/* VOB */}
                                    <Box
                                        style={{
                                            padding: '0.5em 1.0em 0em 1.0em',
                                            marginBottom: '0.5em',
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            { (!isPrivatePay && !isSelfPay) &&
                                                <Grid item xs={8}>
                                                    <Tooltip
                                                        title={isSelfPay ? "VOB is not available for self-pay patients" : ""}
                                                        placement="top"
                                                        disableHoverListener={!isSelfPay && !isPrivatePay}
                                                    >
                                                        <div style={{ width: '100%' }}>
                                                            <TextField
                                                                select={true}
                                                                label="VOB"
                                                                name="vob"
                                                                value={selectedVob}
                                                                onChange={handleVobChange}
                                                                onBlur={() => {}}
                                                                loading={patientVobListLoading}
                                                                test-id="estimate-tab-vob-dropdown"
                                                                disabled={(isSelfPay || isPrivatePay) || isDisabledAfterConvert}
                                                            >
                                                                {vobsList.map((vobItem) => (
                                                                    <MenuItem key={vobItem.id} value={vobItem.id}>
                                                                        {vobItem.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </TextField>
                                                        </div>
                                                    </Tooltip>
                                                </Grid>
                                            }
                                            {!isSelfPay &&
                                                <Grid
                                                    item
                                                    xs={4}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        paddingTop: '16px'
                                                    }}
                                                >
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={isPrivatePay}
                                                                    test-id="estimate-tab-private-pay"
                                                                    onChange={handlePrivatePay}
                                                                    disabled={isDisabledAfterConvert || isPrivatePaySwitching}
                                                                />
                                                            }
                                                            label="Private Pay"
                                                        />
                                                    </FormGroup>
                                                </Grid>
                                            }

                                        </Grid>
                                    </Box>
                                    {/* IOC */}
                                    <Box
                                        style={{
                                            padding: '0.5em 1.0em 1.0em 1.0em',
                                            marginBottom: '1.5em',
                                        }}
                                    >
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <Box width="100%">
                                                    <TextField
                                                        select
                                                        error={Boolean(
                                                            createEstimatorFormik.touched.timingRisk &&
                                                            createEstimatorFormik.errors.timingRisk 
                                                            ? createEstimatorFormik.errors.timingRisk 
                                                            : ""
                                                        )}
                                                        label="Timing Risk"
                                                        name="timingRisk"
                                                        test-id="estimate-tab-timing-risk-dropdown"
                                                        value={createEstimatorFormik.values.timingRisk}
                                                        onChange={(e: Event) => createEstimatorFormik.handleChange(e)}
                                                        onBlur={createEstimatorFormik.handleBlur}
                                                        disabled={isDisabledAfterConvert}
                                                    >
                                                        {timingRisk.map((risk) => (
                                                            <MenuItem
                                                                key={risk.timingRiskId}
                                                                value={risk.timingRiskId}
                                                                test-id={`estimate-tab-timing-risk-option-${risk.timingRiskId}`}
                                                            >
                                                                {risk.timingRiskName}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Box width="100%">
                                                    <TextField
                                                        select
                                                        test-id="estimate-tab-interaction-type"
                                                        label="Interaction Type"
                                                        name="interactionType"
                                                        value={createEstimatorFormik.values.interactionType}
                                                        onChange={createEstimatorFormik.handleChange}
                                                        onBlur={createEstimatorFormik.handleBlur}
                                                        disabled={isDisabledAfterConvert}
                                                    >
                                                        <MenuItem value={'Warm Transfer'} test-id="estimate-tab-interaction-type-option-warm-transfer">Warm Transfer</MenuItem>
                                                        <MenuItem value={'Inbound'} test-id="estimate-tab-interaction-type-option-inbound">Inbound Call</MenuItem>
                                                        <MenuItem value={'Outbound'} test-id="estimate-tab-interaction-type-option-outbound">Outbound Call</MenuItem>
                                                    </TextField>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Paper>
                                {/*Levels of Care */}
                                <Paper test-id="estimate-tab-loc-panel">
                                    <Box
                                        style={{
                                            padding: '1.0em',
                                            marginBottom: '1.5em',
                                        }}
                                        test-id="estimate-tab-loc-container"
                                    >
                                        <Grid
                                            container
                                            justifyContent="space-between"
                                            direction="row"
                                        >
                                            <Grid
                                                item
                                                direction="column"
                                                xs={12}
                                                style={{
                                                    display: 'flex',
                                                    flexWrap: 'wrap',
                                                    paddingBottom: '0.5em',
                                                }}
                                            >
                                                <Typography
                                                    variant="subtitle2"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                    test-id="estimate-tab-loc-title"
                                                >
                                                    <PermContactCalendarIcon
                                                        sx={{
                                                            marginRight: '0.25em',
                                                        }}
                                                    />{' '}
                                                    Levels of Care {rateAsPayorPlan && (
                                                    <>- Rate as: {rateAsPayorPlan.payor.facilityPayorName || rateAsPayorPlan.payor.payorName}{rateAsPayorPlan.plan?.planName && `/${rateAsPayorPlan.plan.planName}`} - {rateAsPayorPlan?.payor?.inNetwork ? 'In Network' : 'Out of Network'}</>
                                                )}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container direction="row">
                                            <Grid item xs={6} direction="column">
                                                <AdmissionDateV3
                                                    admissionDate={initialAdmissionDate}
                                                    onChangeHandler={handleAdmissionDateOnChange}
                                                />
                                            </Grid>
                                            <>
                                                {promptUserToUpdateModalForCrossover && (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        sx={{
                                                            backgroundColor: '#E8DB47',
                                                            marginY: '0.5rem',
                                                        }}
                                                    >
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            className="p-2"
                                                        >
                                                            <span test-id="estimate-tab-crossover-warning">
                                                                Please open the LOC modal
                                                                and update Days Before
                                                                Crossover value(s)
                                                            </span>
                                                        </Grid>
                                                    </Grid>
                                                )}

                                                <NewLOCSummary
                                                    handleLocModalOpen={() => {
                                                        setIsLOCModalOpen(true)
                                                    }}
                                                    enableLOSbutton={
                                                        !isDisabledAfterConvert
                                                    }
                                                    selectedLevelsOfCare={
                                                        estimate?.facilityLevelOfCare ||
                                                        []
                                                    }
                                                    quoteMethod={quoteMethodValueAsEnum}
                                                    displayValueRed={
                                                        doesLOCSummaryValNeedUpdating
                                                    }
                                                    test-id="estimate-tab-loc-summary"
                                                />
                                            </>
                                        </Grid>
                                    </Box>
                                </Paper>
                                {(!isSelfPay && !isPrivatePay) &&
                                    <EstimatorPriorCareSummary test-id="estimate-tab-prior-care-summary" />
                                }

                                {/* Action buttons under Prior Care */}
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: !isIocLinkedToEstimate || isIOCConverted
                                            ? 'space-between'
                                            : 'flex-end',
                                        padding: '20px 0',
                                        backgroundColor: '#F5F7F9'
                                    }}
                                >
                                    {(!isIocLinkedToEstimate || isIOCConverted) && (
                                        <Button
                                            disabled={!Boolean(estimate) || savedEstimatesLoading || isSaving || isCopying}
                                            onClick={() => {
                                                // if encounter exists and is converted, navigate to IOC page
                                                if (isIOCConverted) {
                                                    navigate(`/specialist/dashboard/${selectedPatient?.patientId}?encounter=${selectedEncounter.patientEncounterId}`);
                                                } else {
                                                    // otherwise attach estimate to IOC
                                                    prepareAttachToIoc();
                                                }
                                            }}
                                            test-id="estimate-tab-ioc-action-button"
                                        >
                                            {(() => {
                                                // if encounter exists and is converted, show View Instance of Care
                                                if (isIOCConverted) {
                                                    return "View IOC";
                                                }

                                                // default to Attach to IOC for existing encounters that aren't converted
                                                return "Attach to IOC";
                                            })()}
                                        </Button>
                                    )}
                                    <Button
                                        test-id="estimate-tab-save-estimate-button"
                                        onClick={() => {
                                            if (isDisabledAfterConvert) {
                                                handleCopyEstimate();
                                            } else {
                                                handleSaveEstimate(isPrivatePay, false);
                                            }
                                        }}
                                        disabled={!Boolean(estimate?.estimateId) || isSaving || isCopying}
                                        style={{
                                            minWidth: 'fit-content',
                                            whiteSpace: 'nowrap',
                                            flexShrink: 0
                                        }}
                                    >
                                        {isCopying ? 'Copying...' : isSaving ? 'Saving...' : (isDisabledAfterConvert ? 'Copy' : 'Save')}
                                    </Button>
                                </Box>
                            </Grid>

                            {/* Side section with summaries */}
                            <Grid item direction="column" xs={4} test-id="estimate-tab-right-column">
                                <Box
                                    border={1}
                                    borderColor="primary.main"
                                    p={2}
                                    style={{
                                        backgroundColor: 'white',
                                        marginBottom: '1.5em',
                                    }}
                                    test-id="estimate-tab-financial-summary-box"
                                >
                                    <Typography variant="subtitle2" test-id="estimate-tab-financial-summary-title">
                                        Financial Summary
                                    </Typography>
                                    <SidebarFinancialSummary test-id="estimate-tab-financial-summary" />
                                </Box>

                                {!isDisabledAfterConvert && (
                                    <SidebarPlanYearCrossover test-id="estimate-tab-plan-year-crossover" />
                                )}

                                <SidebarTotalEstimatedPfr test-id="estimate-tab-total-estimated-pfr" />

                                <SidebarPriorCareAdjustment test-id="estimate-tab-prior-care-adjustment" />

                                <Paper test-id="vob-comments-paper">
                                    <div test-id="vob-comments-container" className="px-4 py-4">
                                        <EstimatesSidebar
                                            clientId={selectedPatient?.clientId ? Number(selectedPatient.clientId) : undefined}
                                            clientEmployerId={selectedPatient?.contact?.contactIncome?.clientEmployerId}
                                            payorId={selectedPatientCurrentInsurance?.payorId}
                                            groupNumber={selectedPatientCurrentInsurance?.groupNumber}
                                            memberId={selectedPatientCurrentInsurance?.memberId}
                                        />
                                    </div>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                    {isLOCModalOpen && (
                        <EstimatorLevelOfCareModal
                            open={isLOCModalOpen}
                            clientId={createEstimatorFormik.values.client}
                            facilityId={createEstimatorFormik.values.facility}
                            facilityName={
                                currentFacility?.facilityName || ''
                            }
                            quoteMethod={createEstimatorFormik.values.quoteMethod}
                            admissionDate={admissionDate}
                            facilityLevelsOfCareList={facilityLevelsOfCareList || []}
                            handleEstimatorLevelOfCareModalClose={
                                handleEstimatorLevelOfCareModalClose
                            }
                            promptUserToUpdateModalForCrossover={
                                promptUserToUpdateModalForCrossover
                            }
                            test-id="estimate-tab-loc-modal"
                        />
                    )}

                    <TakePaymentModal
                        paymentData={paymentData}
                        open={openPaymentModal}
                        handleModalCancel={handlePaymentModalCancel}
                        test-id="estimate-tab-payment-modal"
                    />
                </>
            )}
        </>
    );
}

export default EstimateTab;
